import React, { useEffect, useState } from "react";
import triangle from "../Images/triangle.png";
import bloodPressure from "../Images/bloodPressure.png";
import bloodSugar from "../Images/bloodSugar.png";
import kidneyTests from "../Images/kidneyTests.png";
import liverTests from "../Images/liverTests.png";
import lipidProf from "../Images/lipidProf.png";
import bloodCount from "../Images/bloodCount.png";
import bodyTemp from "../Images/bodyTemp.png";
import heartRate from "../Images/heartRate.png";
import respRate from "../Images/respRate.png";
import DietaryRecallTable from "./DietaryRecallTable";
import oxSat from "../Images/oxSat.png";
import addPink from "../Images/addPink.png";
import add from "../Images/addPink.png";
import { Link, useParams } from "react-router-dom";
import "../css/doctors.css";
import toast, { Toaster } from "react-hot-toast"


function DetailedAssessment() {
  const [name, setName] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [sw, setSw] = useState("");
  const [age, setAge] = useState(0);
  const [gender, setGender] = useState("");
  const [weight, setWeight] = useState(0);
  const [diagnosis, setDiagnosis] = useState("");
  const [relation, setRelation] = useState("");
  const [fhDesc, setFhDesc] = useState("");
  const [surgery, setSurgery] = useState("");
  const [wid, setWid] = useState("");
  const [shDesc, setShDesc] = useState("");
  const [wUnit, setWUnit] = useState("");
  const [height, setHeight] = useState(0);
  const [hUnit, setHUnit] = useState("CM");
  const [edit, setEdit] = useState(true);
  const [state, setState] = useState("Maharashtra");
  const [city, setCity] = useState("Mumbai");
  const [edit2, setEdit2] = useState(true);
  const [edit3, setEdit3] = useState(true);
  const [edit4, setEdit4] = useState(true);
  const [edit5, setEdit5] = useState(true);
  const [edit6, setEdit6] = useState(true);
  const [stId, setStId] = useState(1);
  const [ctId, setCtId] = useState(0);
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const { id } = useParams();
 
  const [relationshipStatus, setRelationshipStatus] = useState("UNMARRIED");
  const [bloodGroup, setBloodGroup] = useState("O+");

  const calAge = (birthdate) => {
    const today = new Date();
    const birthDate = new Date(birthdate);
    let calculatedAge = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      calculatedAge--;
    }
    setAge(calculatedAge);
  };

  const fetchState = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/states/`
      );
      const json = await response.json();
      if (response.ok) {
        setAllStates(json);
        // console.log("states",json)
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchCity = async () => {
    try {
      const formData = {
        id: parseInt(stId),
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/cities/`,
        {
          method: "POST",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const json = await response.json();
      if (response.ok) {
        setAllCities(json);
        console.log("cities", json);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCity();
  }, [stId]);

  useEffect(() => {
    fetchState();
    fetchCity();
  }, []);
  //medicalhistory
  const clearMedicalHistoryForm = () => {
    setMedicalHistoryOngoing("");
    setMedicalHistoryOnMedication("");
    setMedicalHistoryWellManaged("");
    setMedicalHistorySinceDate("");
    setMedicalHistoryDescription("");
    setSearchTerm("");
    setSelectedDescription("");
    setFilteredSuggestions([]);
    setShowSuggestions(false);
  };
  const [MedicalHistory, setMedicalHistory ] =useState([])
  const [medicalHistoryAddNew, setMedicalHistoryAddNew] = useState(false);
  const [medicalHistoryEditIndex, setMedicalHistoryEditIndex] = useState(null);
  const [medicalHistories, setMedicalHistories] = useState([]);
  const [medicalHistoryCode, setMedicalHistoryCode] = useState("");
  const [medicalHistoryOngoing, setMedicalHistoryOngoing] = useState("");
  const [medicalHistoryOnMedication, setMedicalHistoryOnMedication] =
    useState("");
   
    // const [medicalHistories, setMedicalHistories] = useState([]);
  const [medicalHistoryWellManaged, setMedicalHistoryWellManaged] =
    useState("");
  const [medicalHistorySinceDate, setMedicalHistorySinceDate] = useState("");
  const [medicalHistoryDescription, setMedicalHistoryDescription] =
    useState("");

  const fetchMedicalHistories = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/medical-histories/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setMedicalHistories(json);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleNewMedicalHistory = async (e) => {
    e.preventDefault();
    try {
      const selectedDiagnosisId = complaintOptions.find(
        (option) => option.code === searchTerm
      )?.id;
      const formData = {
        complaint_code: selectedDiagnosisId
          ? selectedDiagnosisId.toString()
          : "",
        ongoing: medicalHistoryOngoing,
        on_medication: medicalHistoryOnMedication,
        well_managed: medicalHistoryWellManaged,
        since_date: medicalHistorySinceDate,
        description: medicalHistoryDescription,
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/medical-histories/${id}/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        fetchMedicalHistories();
        // Clear input fields
        setMedicalHistoryCode("");
        setSelectedDescription("");
        setMedicalHistoryOngoing("");
        setMedicalHistoryOnMedication("");
        setMedicalHistoryWellManaged("");
        setMedicalHistorySinceDate("");
        setMedicalHistoryDescription("");
        setSearchTerm("");
        setFilteredSuggestions([]);
        setShowSuggestions(false);
        setMedicalHistoryAddNew(false);
      }

      toast.success('Changes Saved Successfully!')

    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleUpdateMedicalHistory = async (e, medicalHistoryId) => {
    e.preventDefault();
    console.log("Updating Medical History:", {
      medicalHistoryId,
      searchTerm,
      complaintOptions,
      medicalHistoryCode,
    });

    try {
      //find selected diagnosis id based on the search term

      let selectedDiagnosisId = null;

      selectedDiagnosisId = complaintOptions.find(
        (option) => option.code === searchTerm
      )?.id;

      if (!selectedDiagnosisId) {
        selectedDiagnosisId = complaintOptions.find(
          (option) => option.id === parseInt(medicalHistoryCode)
        )?.id;
      }
      if (!selectedDiagnosisId) {
        selectedDiagnosisId = medicalHistoryCode;
      }
      console.log(selectedDiagnosisId);

      const formData = {
        complaint_code: selectedDiagnosisId
          ? selectedDiagnosisId.toString()
          : medicalHistoryCode || "",
        ongoing: medicalHistoryOngoing,
        on_medication: medicalHistoryOnMedication,
        well_managed: medicalHistoryWellManaged,
        since_date: medicalHistorySinceDate,
        description: medicalHistoryDescription,
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/medical-histories/${id}/${medicalHistoryId}/`,
        {
          method: "PUT",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();
      if (response.ok) {
        console.log("Updated medical history", responseData);
        //reset edit mode
        setMedicalHistoryEditIndex(null);
        //reset search and suggestion states
        setSearchTerm("");
        setFilteredSuggestions([]);
        setShowSuggestions(false);
        setSelectedDescription("");

        fetchMedicalHistories();
      } else {
        console.error("Failed to update medical history:", {
          status: response.status,
          responseData,
        });
      }

      toast.success('Changes Saved Successfully!')

    } catch (error) {
      console.log("Error updating medical history:", error);
    }
  };

  const handleEditMedicalHistory = (medicalHistoryId, medicalHistory) => {
    setMedicalHistoryEditIndex(medicalHistoryId);

    const currentMedicalHistory =
      complaintOptions.find(
        (opt) => opt.id === parseInt(medicalHistory.complaint_code)
      ) ||
      complaintOptions.find(
        (opt) => opt.code === medicalHistory.complaint_code
      );
    setSearchTerm(
      currentMedicalHistory?.code || MedicalHistory.complaint_code || ""
    );
    //set the selected description
    setSelectedDescription(
      currentMedicalHistory?.description ||
        currentMedicalHistory?.long_description ||
        medicalHistory.description ||
        ""
    );
    setMedicalHistoryCode(
      currentMedicalHistory?.id?.toString() ||
        medicalHistory.complaint_code ||
        ""
    );
    setMedicalHistoryOngoing(medicalHistory.ongoing || "");
    setMedicalHistoryOnMedication(medicalHistory.on_medication || "");
    setMedicalHistoryWellManaged(medicalHistory.well_managed || "");
    setMedicalHistorySinceDate(medicalHistory.since_date || "");
    setMedicalHistoryDescription(medicalHistory.description || "");
  };

  useEffect(() => {
    fetchData();
    fetchData2();
    fetchData3();
    fetchData4();
    fetchData5();
    fetchData6();
    fetchData7();
    fetchData8();
    fetchData9();
    fetchMedicalHistories(); // Add this line
  }, []);
  //healthproblems
  const [hg, setHg] = useState("PCOD Management");

  const [healthProblems, setHealthProblems] = useState([]);
  const [selectedOilTypes, setSelectedOilTypes] = useState([]);
  const [healthProblems3, setHealthProblems3] = useState([]);
  const [healthProblems4, setHealthProblems4] = useState([]);
  const [healthProblems5, setHealthProblems5] = useState([]);
  const [healthProblems6, setHealthProblems6] = useState([]);
  const [fpLikes, setFpLikes] = useState("");
  const [fpDislikes, setFpDislikes] = useState("");
  const [oiPerM, setOiPerM] = useState("");
  const [siPerM, setSiPerM] = useState("");
  const [otSalt, setOtSalt] = useState("");
  const [otMilk, setOtMilk] = useState("");
  const [dtIndex, setDtIndex] = useState(0);
  const [foodPrefRecordId, setFoodPrefRecordId] = useState(0);
  const [otFlour, setOtFlour] = useState("");


  const [dietPref, setDietPref] = useState({});

  useEffect(() => {
    if (Object.keys(dietPref).length > 0 && dietPref.food_preferences) {
      setDtIndex(1);
    } else {
      setDtIndex(0);
    }
  }, [dietPref]);

  useEffect(() => {
    if (dietPref && Object.keys(dietPref).length > 0) {
      setHealthProblems(dietPref.food_preferences || []);
      setSelectedOilTypes(dietPref.oil_type || []);
      setHealthProblems3(dietPref.salt_type || []);
      setHealthProblems4(dietPref.flour_type || []);
      setHealthProblems5(dietPref.milk_type || []);
      setHealthProblems6(dietPref.milk_products || []);
      setFpLikes(dietPref.likes || "");
      setFpDislikes(dietPref.dislikes || "");
      setOiPerM(dietPref.oil_intake_per_month || "");
      setSiPerM(dietPref.salt_inlake || "");
      setOtSalt(dietPref.other_specify_salt || "");
      setOtMilk(dietPref.other_specify_milk || "");
      setOtFlour(dietPref.other_specify_flour || "");
    }
  }, [dietPref]);

  ///////////

  const handleHp = (index) => {
    if (!edit5 || globalEdit) {
      setHealthProblems(prev => 
        prev.includes(index) 
          ? prev.filter(item => item !== index)
          : [...prev, index]
      );
    }
  };

  const handleSave = () => {
    setEdit5(true);
    setGlobalEdit(false);
  };

  const handleEdit = () => {
    setEdit5(false);
    setGlobalEdit(true);
  };

  const handleHp2 = (value) => {
    if (!edit5 || globalEdit) {
      const numValue = Number(value);
      setSelectedOilTypes((prev) =>
        prev.includes(numValue)
          ? prev.filter((v) => v !== numValue)
          : [...prev, numValue]
      );
    }
  };

  const handleHp3 = (value) => {
    if (!edit5 || globalEdit) {
      const numValue = Number(value);
      setHealthProblems3((prev) =>
        prev.includes(numValue)
          ? prev.filter((v) => v !== numValue)
          : [...prev, numValue]
      );
    }
  };

  const handleHp4 = (value) => {
    if (!edit5 || globalEdit) {
      const numValue = Number(value);
      setHealthProblems4((prev) =>
        prev.includes(numValue)
          ? prev.filter((v) => v !== numValue)
          : [...prev, numValue]
      );
    }
  };

  const handleHp5 = (value) => {
    if (!edit5 || globalEdit) {
      const numValue = Number(value);
      setHealthProblems5((prev) =>
        prev.includes(numValue)
          ? prev.filter((v) => v !== numValue)
          : [...prev, numValue]
      );
    }
  };

  const handleHp6 = (value) => {
    if (!edit5 || globalEdit) {
      const numValue = Number(value);
      setHealthProblems6((prev) =>
        prev.includes(numValue)
          ? prev.filter((v) => v !== numValue)
          : [...prev, numValue]
      );
    }
  };

  useEffect(() => {
    console.log(healthProblems6);
  }, [healthProblems6]);

  const [patient, setPatient] = useState([]);
  const [com, setCom] = useState([]);
  const [wa_phone_number, setWa_phone_number] = useState("");
  const [alternate_phone_number, setAlternate_phone_number] = useState("");
  const [email_id, setEmail_id] = useState("");
  const [address, setAddress] = useState("");
  const [vitals, setVitals] = useState([]);
  const [chiefComp, setChiefComp] = useState([]);

  const [medications, setMedications] = useState([]);
  const [surgicalHistory, setSurgicalHistory] = useState([]);
  const [familyHistory, setFamilyHistory] = useState([]);
  const [otherInfo, setOtherInfo] = useState({
    id: 0,
    water_intake: 1, // Default to "Glasses"
    water_intake_quantity: 0,
    urination_count: 0,
    stool_frequency: 0,
    sleep_hours: 0,
    spectacles: "NO",
    has_bp_monitor: "NO",
    has_glucometer_monitor: "NO",
    has_weighing_monitor: "NO",
    wake_up_feeling: 1,
    energy_level: 1,
    stress_level: 1,
    family_time: 1,
    health_literacy: 1,
  });

  const [uot, setUot] = useState(false);

  const [complaintCode, setComplaintCode] = useState("");
  const [ongoing, setOngoing] = useState("");
  const [onMedication, setOnMedication] = useState("");
  const [wellManaged, setWellManaged] = useState("");
  const [duration, setDuration] = useState("");
  const [sinceDate, setSinceDate] = useState("");
  const [description, setDescription] = useState("");
  const [ccEdit, setCcEdit] = useState(false);

  const [complaintOptions, setComplaintOptions] = useState([]);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [surgeryOptions, setSurgeryOptions] = useState([]);
  const [displayedComplaints, setDisplayedComplaints] = useState([]);
  const COMPLAINTS_PER_PAGE = 400;
  const [isLoadingComplaints, setIsLoadingComplaints] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchComplaintOptions = async () => {
      setIsLoadingComplaints(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/chief-complaints-options/`
        );
        if (response.ok) {
          const data = await response.json();
          setComplaintOptions(data);
          setDisplayedComplaints(data.slice(0, COMPLAINTS_PER_PAGE));
          setIcdCodes(data);
        }
      } catch (error) {
        console.error("Error fetching complaint options:", error);
      } finally {
        setIsLoadingComplaints(false);
      }
    };

    const fetchSurgeryOptions = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/surgery-options/`
        );
        if (response.ok) {
          const data = await response.json();
          setSurgeryOptions(data);
        }
      } catch (error) {
        console.error("Error fetching complaint options:", error);
      }
    };

    fetchComplaintOptions();
    fetchComplaintOptions();
    fetchSurgeryOptions();
  }, []);

  const handleComplaintSearch = (searchText) => {
    setSearchTerm(searchText);
    if (!searchText.trim()) {
      setDisplayedComplaints(complaintOptions.slice(0, COMPLAINTS_PER_PAGE));
      return;
    }

    const filtered = complaintOptions
      .filter(
        (option) =>
          option.code.toLowerCase().includes(searchText.toLowerCase()) ||
          (option.description &&
            option.description.toLowerCase().includes(searchText.toLowerCase()))
      )
      .slice(0, COMPLAINTS_PER_PAGE);

    setDisplayedComplaints(filtered);
  };

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/patients/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setPatient(json);
        setName(json.full_name);
        setGender(json.gender);
        setHeight(json.height);
        setWeight(json.weight);
        setWUnit(json.weight_unit);
        setBirthdate(json.birthdate);
        setRelationshipStatus(json.relationship);
        setBloodGroup(json.blood_group);
        setStId(json.state);
        setCtId(json.city);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData2 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/communications/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setCom(json);
        setWa_phone_number(json.wa_phone_number);
        setAlternate_phone_number(json.alternate_phone_number);
        setEmail_id(json.email_id);
        setAddress(json.address);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData3 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/vitals/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setVitals(json);
        console.log("vitals", vitals);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData10 = async (vat) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/vitals/${id}/${vat}/`
      );
      const json = await response.json();
      if (response.ok) {
        setVitals(json);
        console.log("vitals per date", vitals);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData4 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/chief-complaints/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setChiefComp(json);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData5 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/medications/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setMedications(json);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData6 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/surgical-histories/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setSurgicalHistory(json);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData7 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/dietary-preferences/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setDietPref(json);
        setFoodPrefRecordId(json.id);
        setHealthProblems(json.food_preferences || []);
        setSelectedOilTypes(json.oil_type || []);
        setHealthProblems3(json.salt_type || []);
        setHealthProblems4(json.flour_type || []);
        setHealthProblems5(json.milk_type || []);
        setHealthProblems6(json.milk_products || []);
        setFpLikes(json.likes || "");
        setFpDislikes(json.dislikes || "");
        setOiPerM(json.oil_intake_per_month || "");
        setSiPerM(json.salt_inlake || "");
        setOtSalt(json.other_specify_salt || "");
        setOtMilk(json.other_specify_milk || "");
        setOtFlour(json.other_specify_flour || "");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData9 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/family-history/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setFamilyHistory(json);
      }
      console.log(familyHistory);
    } catch (error) {
      console.log(error);
    }
  };
  // new BC URL: http://145.223.21.89:8000/
  const [otherInfoRecordId, setOtherInfoRecordId] = useState(0);
  const fetchData8 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/other-informations/${id}/`
      );
      const json = await response.json();
      if (response.ok) {
        setOtherInfo({
          ...json,
          water_intake: json.water_intack, // Fix the field name mismatch
        });
        setUot(true);
        setOtherInfoRecordId(json.id);
      }
      console.log(json);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
    fetchData2();
    fetchData3();
    fetchData4();
    fetchData5();
    fetchData6();
    fetchData7();
    fetchData8();
    fetchData9();
  }, []);

  useEffect(() => {
    console.log(surgeryOptions, "SURGERY OPTIONS");
  }, [surgeryOptions]);

  const [medIndex, setMedIndex] = useState(0);
  const [fhIndex, setFhIndex] = useState(0);
  const [shIndex, setShIndex] = useState(0);

  const handleMedLeftSlide = () => {
    if (medIndex > 0) {
      setMedIndex(medIndex - 1);
      console.log(medIndex);
    }
  };
  const handleMedRightSlide = () => {
    if (medIndex < medications.length - 1) {
      setMedIndex(medIndex + 1);
      console.log(medIndex);
    }
  };
  const handleFhLeftSlide = () => {
    if (fhIndex > 0) {
      setFhIndex(fhIndex - 1);
      console.log(fhIndex);
    }
  };
  const handleFhRightSlide = () => {
    if (fhIndex < familyHistory.length - 1) {
      setFhIndex(fhIndex + 1);
      console.log(fhIndex);
    }
  };
  const handleShLeftSlide = () => {
    if (shIndex > 0) {
      setShIndex(shIndex - 1);
      console.log(shIndex);
    }
  };
  const handleShRightSlide = () => {
    if (shIndex < surgicalHistory.length - 1) {
      setShIndex(shIndex + 1);
      console.log(shIndex);
    }
  };

  const [ccAddNew, setCcAddNew] = useState(false);
  const [medAddNew, setMedAddNew] = useState(false);
  const [fhAddNew, setFhAddNew] = useState(false);
  const [shAddNew, setShAddNew] = useState(false);

  const [globalEdit, setGlobalEdit] = useState(false);

  function handleGlobalEdit() {
    setEdit(false);
    setEdit2(false);
    setEdit3(false);
    setEdit4(false);
    setEdit5(false);
    setEdit6(false);
    setGlobalEdit(true);
  }

 // In your handleGlobalSave function:
async function handleGlobalSave() {
  try {
    await updatePersonalInfo();
    await handleUpdateVital();
    await handleFpSubmit(); // Make sure to await this
    await handleUpdateOtherInfo();
    await handleComSubmit();
    
    setEdit(true);
    setGlobalEdit(false);
    setEdit2(true);
    setEdit3(true);
    setEdit4(true);
    setEdit5(true);
    setEdit6(true);

    toast.success('Changes Saved Successfully!')
  } catch (error) {
    console.error('Error saving changes:', error);
    alert('Failed to save some changes. Please try again.');
  }
}

  const updatePersonalInfo = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (edit || globalEdit) {
      try {
        if (
          name === "" ||
          birthdate === "" ||
          gender === "" ||
          weight === "" ||
          height === ""
        ) {
          return console.log("Enter all data");
        }

        const formData = {
          full_name: name,
          birthdate: birthdate,
          gender: gender,
          weight: weight,
          height: height,
          weight_unit: wUnit,
          height_unit: hUnit,
          state: parseInt(stId),
          city: parseInt(ctId),
          blood_group: bloodGroup,
          relationship: relationshipStatus,
        };

        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/patients/${id}/`,
          {
            method: "PUT",
            body: JSON.stringify(formData),
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const json = await response.json();
        if (response.ok) {
          fetchData();
          console.log("updated patient", json);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleComSubmit = async () => {
    try {
      const formData = {
        wa_phone_number: wa_phone_number || 0,
        alternate_phone_number: alternate_phone_number || 0,
        email_id: email_id || "fill out this field",
        address: address || "fill out this field",
      };

      // write a small regex to check if the email is valid
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email_id)) {
        document.getElementById("email_id_error").style.display = "block";
        return;
      }
      document.getElementById("email_id_error").style.display = "none";

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/communications/${id}/`,
        {
          method: "PUT",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const json = await response.json();
      if (response.ok) {
        console.log("added communications");
        console.log(json);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Vitals
  const [sys, setSys] = useState("");
  const [dia, setDia] = useState("");

  // Blood Sugar State
  const [fastGlucose, setFastGlucose] = useState("");
  const [postGlucose, setPostGlucose] = useState("");
  const [hemoglobinA1c, setHemoglobinA1c] = useState("");

  // Kidney Function State
  const [serumCr, setSerumCr] = useState("");
  const [bun, setBun] = useState("");
  const [eGFR, setEGFR] = useState("");
  const [sodium, setSodium] = useState("");
  const [potassium, setPotassium] = useState("");

  // Liver Function State
  const [alt, setAlt] = useState("");
  const [ast, setAst] = useState("");
  const [alp, setAlp] = useState("");
  const [bilirubin, setBilirubin] = useState("");
  const [albumin, setAlbumin] = useState("");
  const [protein, setProtein] = useState("");

  // Lipid Profile State
  const [cholesterol, setCholesterol] = useState("");
  const [ldl, setLdl] = useState("");
  const [hdl, setHdl] = useState("");
  const [triglycerides, setTriglycerides] = useState("");

  // Complete Blood Count State
  const [wbc, setWbc] = useState("");
  const [rbc, setRbc] = useState("");
  const [hemoglobin, setHemoglobin] = useState("");
  const [hematocrit, setHematocrit] = useState("");
  const [platelets, setPlatelets] = useState("");
  const [mcv, setMcv] = useState("");
  const [mchc, setMchc] = useState("");
  const [mchcpg, setMchcpg] = useState("");

  // Body Temperature State
  const [temp, setTemp] = useState("");

  // Heart Rate State
  const [hr, setHr] = useState("");

  // Respiratory Rate State
  const [rr, setRr] = useState("");

  // Oxygen Saturation State
  const [o2Sat, setO2Sat] = useState("");

  // Assuming `vitals` is available as the provided data
  useEffect(() => {
    if (vitals && vitals.vitals) {
      // Blood Pressure
      if (vitals.vitals.blood_pressure.length > 0) {
        setSys(vitals.vitals.blood_pressure[0].systolic || "");
        setDia(vitals.vitals.blood_pressure[0].diastolic || "");
      }

      // Blood Sugar
      if (vitals.vitals.blood_sugar.length > 0) {
        setFastGlucose(
          vitals.vitals.blood_sugar[0].fasting_blood_glucose || ""
        );
        setPostGlucose(
          vitals.vitals.blood_sugar[0].postprandial_blood_glucose || ""
        );
        setHemoglobinA1c(vitals.vitals.blood_sugar[0].hemoglobin_A1c || "");
      }

      // Kidney Function
      if (vitals.vitals.kidney_function.length > 0) {
        setSerumCr(vitals.vitals.kidney_function[0].serum_creatinine || "");
        setBun(vitals.vitals.kidney_function[0].blood_urea_nitrogen || "");
        setEGFR(vitals.vitals.kidney_function[0].estimated_GFR || "");
        setSodium(vitals.vitals.kidney_function[0].electrolytes_sodium || "");
        setPotassium(
          vitals.vitals.kidney_function[0].electrolytes_potassium || ""
        );
      }

      // Liver Function
      if (vitals.vitals.liver_function.length > 0) {
        setAlt(vitals.vitals.liver_function[0].alanine_aminotransferase || "");
        setAst(
          vitals.vitals.liver_function[0].aspartate_aminotransferase || ""
        );
        setAlp(vitals.vitals.liver_function[0].alkaline_phosphatase || "");
        setBilirubin(vitals.vitals.liver_function[0].total_bilirubin || "");
        setAlbumin(vitals.vitals.liver_function[0].albumin || "");
        setProtein(vitals.vitals.liver_function[0].total_protein || "");
      }

      // Lipid Profile
      if (vitals.vitals.lipid_profile.length > 0) {
        setCholesterol(vitals.vitals.lipid_profile[0].total_cholesterol || "");
        setLdl(vitals.vitals.lipid_profile[0].LDL_cholesterol || "");
        setHdl(vitals.vitals.lipid_profile[0].HDL_cholesterol || "");
        setTriglycerides(vitals.vitals.lipid_profile[0].triglycerides || "");
      }

      // Complete Blood Count
      if (vitals.vitals.cbc.length > 0) {
        setWbc(vitals.vitals.cbc[0].white_blood_cells || "");
        setRbc(vitals.vitals.cbc[0].red_blood_cells || "");
        setHemoglobin(vitals.vitals.cbc[0].hemoglobin || "");
        setHematocrit(vitals.vitals.cbc[0].hematocrit || "");
        setPlatelets(vitals.vitals.cbc[0].platelet_count || "");
        setMcv(vitals.vitals.cbc[0].mean_corpuscular_volume || "");
        setMchc(
          vitals.vitals.cbc[0].mean_corpuscular_hemoglobin_concentration || ""
        );
        setMchcpg(vitals.vitals.cbc[0].mean_corpuscular_volume_pg || "");
      }

      // Body Temperature
      if (vitals.vitals.body_temperature.length > 0) {
        setTemp(vitals.vitals.body_temperature[0].body_temperature || "");
      }

      // Heart Rate
      if (vitals.vitals.heart_rate.length > 0) {
        setHr(vitals.vitals.heart_rate[0].heart_rate || "");
      }

      // Respiratory Rate
      if (vitals.vitals.respiratory_rate.length > 0) {
        setRr(vitals.vitals.respiratory_rate[0].respiratory_rate || "");
      }

      // Oxygen Saturation
      if (vitals.vitals.oxygen_saturation.length > 0) {
        setO2Sat(vitals.vitals.oxygen_saturation[0].oxygen_saturation || "");
      }
    }
  }, [vitals]);

  // OnChange Handlers
  const handleSysChange = (e) => setSys(e.target.value);
  const handleDiaChange = (e) => setDia(e.target.value);

  const handleFastGlucoseChange = (e) => setFastGlucose(e.target.value);
  const handlePostGlucoseChange = (e) => setPostGlucose(e.target.value);
  const handleHemoglobinA1cChange = (e) => setHemoglobinA1c(e.target.value);

  const handleSerumCrChange = (e) => setSerumCr(e.target.value);
  const handleBunChange = (e) => setBun(e.target.value);
  const handleEGFRChange = (e) => setEGFR(e.target.value);
  const handleSodiumChange = (e) => setSodium(e.target.value);
  const handlePotassiumChange = (e) => setPotassium(e.target.value);

  const handleAltChange = (e) => setAlt(e.target.value);
  const handleAstChange = (e) => setAst(e.target.value);
  const handleAlpChange = (e) => setAlp(e.target.value);
  const handleBilirubinChange = (e) => setBilirubin(e.target.value);
  const handleAlbuminChange = (e) => setAlbumin(e.target.value);
  const handleProteinChange = (e) => setProtein(e.target.value);

  const handleCholesterolChange = (e) => setCholesterol(e.target.value);
  const handleLdlChange = (e) => setLdl(e.target.value);
  const handleHdlChange = (e) => setHdl(e.target.value);
  const handleTriglyceridesChange = (e) => setTriglycerides(e.target.value);

  const handleWbcChange = (e) => setWbc(e.target.value);
  const handleRbcChange = (e) => setRbc(e.target.value);
  const handleHemoglobinChange = (e) => setHemoglobin(e.target.value);
  const handleHematocritChange = (e) => setHematocrit(e.target.value);
  const handlePlateletsChange = (e) => setPlatelets(e.target.value);
  const handleMcvChange = (e) => setMcv(e.target.value);
  const handleMchcChange = (e) => setMchc(e.target.value);
  const handleMchcpgChange = (e) => setMchcpg(e.target.value);

  const handleTempChange = (e) => setTemp(e.target.value);

  const handleHrChange = (e) => setHr(e.target.value);

  const handleRrChange = (e) => setRr(e.target.value);

  const handleO2SatChange = (e) => setO2Sat(e.target.value);

  const [editIndex, setEditIndex] = useState(null);
  const handleComplaintCodeChange = (e) => setComplaintCode(e.target.value);
  const handleOngoingChange = (e) => setOngoing(e.target.value);
  const handleOnMedicationChange = (e) => setOnMedication(e.target.value);
  const handleWellManagedChange = (e) => setWellManaged(e.target.value);
  const handleSinceDateChange = (e) => setSinceDate(e.target.value);
  const handleDurationChange = (e) => setDuration(e.target.value);
  const handleDescriptionChange = (e) => setDescription(e.target.value);

  const [editMode, setEditMode] = useState({
    bloodPressure: false,
    bloodSugar: false,
    kidneyTests: false,
    liverTests: false,
    lipidProfile: false,
    cbc: false,
    bodyTemperature: false,
    heartRate: false,
    respiratoryRate: false,
    oxygenSaturation: false,
  });

  const handleEditClick = (section) => {
    setEditMode((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const handleSurgery = (e) => {
    setSurgery(e.target.value);
  };

  const handleCreateVital = async (e) => {
    e.preventDefault();
    try {
      const formData = {
        blood_pressure: [
          {
            systolic: parseFloat(sys), // Convert to number
            diastolic: parseFloat(dia), // Convert to number
          },
        ],
        blood_sugar: [
          {
            fasting_blood_glucose: parseFloat(fastGlucose) || null, // Convert to number
            postprandial_blood_glucose: parseFloat(postGlucose) || null, // Convert to number
            hemoglobin_A1c: parseFloat(hemoglobinA1c) || null, // Convert to number
          },
        ],
        kidney_function: [
          {
            serum_creatinine: parseFloat(serumCr), // Convert to number
            blood_urea_nitrogen: parseFloat(bun), // Convert to number
            estimated_GFR: parseFloat(eGFR), // Convert to number
            electrolytes_sodium: parseFloat(sodium), // Convert to number
            electrolytes_potassium: parseFloat(potassium), // Convert to number
          },
        ],
        liver_function: [
          {
            alanine_aminotransferase: parseFloat(alt), // Convert to number
            aspartate_aminotransferase: parseFloat(ast), // Convert to number
            alkaline_phosphatase: parseFloat(alp), // Convert to number
            total_bilirubin: parseFloat(bilirubin), // Convert to number
            albumin: parseFloat(albumin), // Convert to number
            total_protein: parseFloat(protein), // Convert to number
          },
        ],
        lipid_profile: [
          {
            total_cholesterol: parseFloat(cholesterol), // Convert to number
            LDL_cholesterol: parseFloat(ldl), // Convert to number
            HDL_cholesterol: parseFloat(hdl), // Convert to number
            triglycerides: parseFloat(triglycerides), // Convert to number
          },
        ],
        cbc: [
          {
            white_blood_cells: parseFloat(wbc), // Convert to number
            red_blood_cells: parseFloat(rbc), // Convert to number
            hemoglobin: parseFloat(hemoglobin), // Convert to number
            hematocrit: parseFloat(hematocrit), // Convert to number
            platelet_count: parseFloat(platelets), // Convert to number
            mean_corpuscular_volume: parseFloat(mcv), // Convert to number
            mean_corpuscular_hemoglobin_concentration: parseFloat(mchc), // Convert to number
          },
        ],
        body_temperature: [
          {
            body_temperature: parseFloat(temp), // Convert to number
          },
        ],
        heart_rate: [
          {
            heart_rate: parseFloat(hr), // Convert to number
          },
        ],
        respiratory_rate: [
          {
            respiratory_rate: parseFloat(rr), // Convert to number
          },
        ],
        oxygen_saturation: [
          {
            oxygen_saturation: parseFloat(o2Sat), // Convert to number
          },
        ],
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/vitals/${id}/`,
        {
          method: "POST",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log("added vitals");
        fetchData3();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateVital = async () => {
    try {
      const formData = {
        blood_pressure: [
          {
            systolic: Number(sys) || null, // Convert to number
            diastolic: Number(dia) || null, // Convert to number
          },
        ],
        blood_sugar: [
          {
            fasting_blood_glucose: Number(fastGlucose) || null, // Convert to number
            postprandial_blood_glucose: Number(postGlucose) || null, // Convert to number
            hemoglobin_A1c: Number(hemoglobinA1c) || null, // Convert to number
          },
        ],
        kidney_function: [
          {
            serum_creatinine: Number(serumCr) || null, // Convert to number
            blood_urea_nitrogen: Number(bun) || null, // Convert to number
            estimated_GFR: Number(eGFR) || null, // Convert to number
            electrolytes_sodium: Number(sodium) || null, // Convert to number
            electrolytes_potassium: Number(potassium) || null, // Convert to number
          },
        ],
        liver_function: [
          {
            alanine_aminotransferase: Number(alt) || null, // Convert to number
            aspartate_aminotransferase: Number(ast) || null, // Convert to number
            alkaline_phosphatase: Number(alp) || null, // Convert to number
            total_bilirubin: Number(bilirubin) || null, // Convert to number
            albumin: Number(albumin) || null, // Convert to number
            total_protein: Number(protein) || null, // Convert to number
            indirect_bilirubin: Number(indirectBilirubin) || null, // Convert to number
            direct_bilirubin: Number(directBilirubin) || null, // Convert to number
          },
        ],
        lipid_profile: [
          {
            total_cholesterol: Number(cholesterol) || null, // Convert to number
            LDL_cholesterol: Number(ldl) || null, // Convert to number
            HDL_cholesterol: Number(hdl) || null, // Convert to number
            triglycerides: Number(triglycerides) || null, // Convert to number
          },
        ],
        cbc: [
          {
            white_blood_cells: Number(wbc) || null, // Convert to number
            red_blood_cells: Number(rbc) || null, // Convert to number
            hemoglobin: Number(hemoglobin) || null, // Convert to number
            hematocrit: Number(hematocrit) || null, // Convert to number
            platelet_count: Number(platelets) || null, // Convert to number
            mean_corpuscular_volume: Number(mcv) || null, // Convert to number
            mean_corpuscular_hemoglobin_concentration: Number(mchc) || null, // Convert to number
            mean_corpuscular_volume_pg: Number(mchcpg) || null, // Convert to number
          },
        ],
        body_temperature: [
          {
            body_temperature: Number(temp) || null, // Convert to number
          },
        ],
        heart_rate: [
          {
            heart_rate: Number(hr) || null, // Convert to number
          },
        ],
        respiratory_rate: [
          {
            respiratory_rate: Number(rr) || null, // Convert to number
          },
        ],
        oxygen_saturation: [
          {
            oxygen_saturation: Number(o2Sat) || null, // Convert to number
          },
        ],
      };

      console.log(formData);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/vitals/${id}/`,
        {
          method: "PUT",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log("updated vital");
        fetchData3();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleNewCc = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/chief-complaints/${id}/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            complaint_code: complaintCode,
            ongoing: ongoing,
            on_medication: onMedication,
            well_managed: wellManaged,
            since_date: sinceDate,
            description: description,
          }),
        }
      );

      if (response.ok) {
        fetchData4();
        // Clear all input fields after successful save
        setComplaintCode("");
        setSelectedDescription("");
        setOngoing("");
        setOnMedication("");
        setWellManaged("");
        setSinceDate("");
        setDescription("");
        setSearchTerm("");
        setFilteredSuggestions([]);
        setShowSuggestions("");
        setCcAddNew(false); // Close the add new form
      }
      toast.success('Changes Saved Successfully!')

    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleUpdateCc = async (e, complaintId) => {
    e.preventDefault();
    try {
      // Only proceed with update if we're in edit mode
      if (editIndex === complaintId) {
        const formData = {
          complaint_code: complaintCode,
          ongoing: ongoing,
          on_medication: onMedication,
          well_managed: wellManaged,
          since_date: sinceDate,
          description: description,
        };

        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/chief-complaints/${id}/${complaintId}/`,
          {
            method: "PUT",
            body: JSON.stringify(formData),
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const json = await response.json();
        if (response.ok) {
          console.log("Updated chief complaint");
          setEditIndex(null); // Exit edit mode
          fetchData4(); // Refresh the complaints list
        }
      }

      toast.success('Changes Saved Successfully!')

    } catch (error) {
      console.log(error);
    }
  };

  const handleEditClickCc = (complaintId, complaint) => {
    setEditIndex(complaintId);
    setComplaintCode(complaint.complaint_code || "");

    const currentComplaint = complaintOptions.find(
      (opt) => opt.id === parseInt(complaint.complaint_code)
    );
    setSearchTerm(currentComplaint ? currentComplaint.code : "");

    setOngoing(complaint.ongoing || "");
    setOnMedication(complaint.on_medication || "");
    setWellManaged(complaint.well_managed || "");
    setSinceDate(complaint.since_date || "");
    setDuration(complaint.duration || "");
    setDescription(complaint.description || "");
  };

  const [drugName, setDrugName] = useState("");
  const [drugStrength, setDrugStrength] = useState("");
  const [drugFrequency, setDrugFrequency] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [tillDate, setTillDate] = useState("");
  const [medEditIndex, setMedEditIndex] = useState(null);
  const [fhEditIndex, setFhEditIndex] = useState(null);
  const [shEditIndex, setShEditIndex] = useState(null);

  const handleMedSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = {
        drug_name: drugName,
        drug_strength: drugStrength,
        drug_frequency: drugFrequency,
        from_date: fromDate,
        till_date: tillDate,
        description: description,
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/medications/${id}/`,
        {
          method: "POST",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log("added medication");
        // Clear all inputs
        setDrugName("");
        setDrugStrength("");
        setDrugFrequency("");
        setFromDate("");
        setTillDate("");
        setDescription("");
        setMedAddNew(false);
        fetchData5();
      }

      toast.success('Changes Saved Successfully!')

    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateMed = async (e, index) => {
    e.preventDefault();
    try {
      const formData = {
        drug_name: drugName,
        drug_strength: drugStrength,
        drug_frequency: drugFrequency,
        from_date: fromDate,
        till_date: tillDate,
        description: description,
      };

      console.log(formData);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/medications/${id}/${index}/`,
        {
          method: "PUT",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log("updated medications");
        fetchData5();
      }
      toast.success('Changes Saved Successfully!')

    } catch (error) {
      console.log(error);
    }
  };

  const handleFhSubmit = async (e) => {
    e.preventDefault();
    try {
      const selectedDiagnosisId = complaintOptions.find(
        (option) => option.code === searchTerm
      )?.id;
      const formData = {
        relation: relation,
        diagnosis: selectedDiagnosisId ? selectedDiagnosisId.toString() : "",
        sins_when: sw,
        descriptions: fhDesc,
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/family-history/${id}/`,
        {
          method: "POST",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log("added family history");
        // Clear all inputs
        setRelation("");
        setDiagnosis("");
        setSw("");
        setFhDesc("");
        setSearchTerm("");
        setSelectedDescription("");
        setFhAddNew(false);
        fetchData9();
      }

      toast.success('Changes Saved Successfully!')

    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateFh = async (e, index) => {
    e.preventDefault();
    try {
      const formData = {
        relation: relation,
        diagnosis: diagnosis,
        sins_when: sw,
        descriptions: fhDesc,
      };

      console.log(formData);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/family-history/${id}/${index}/`,
        {
          method: "PUT",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log("updated family history");
        fetchData9();
        toast.success('Changes Saved Successfully!'); // Add this line
      }
    } catch (error) {
      console.log(error);
    }
};

  // const allSur = ["Cataract surgery", "Cataract surgery2"];

  const handleShSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = {
        surgery: surgery,
        when_dose: wid,
        description: shDesc,
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/surgical-histories/${id}/`,
        {
          method: "POST",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log("added surgical history");
        // Reset all form fields including surgery dropdown
        setSurgery(""); // Reset to empty string so dropdown shows "Select surgery"
        setWid("");
        setShDesc("");
        setShAddNew(false);
        fetchData6();
      }
      // toast.success('Changes Saved Successfully!')

    } catch (error) {
      console.log(error);
    }
};

  const handleUpdateSh = async (e, index) => {
    e.preventDefault();
    try {
      const formData = {
        surgery: surgery,
        when_dose: wid,
        description: shDesc,
      };

      console.log(formData);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/surgical-histories/${id}/${index}/`,
        {
          method: "PUT",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log("updated surgical history");
        fetchData6();
        toast.success('Changes Saved Successfully!')

      }
    } catch (error) {
      console.log(error);
    }
  };

  const [dtOpt, setDtOpt] = useState([]);

  const dietOptions = [
    "Vegetarian",
    "Vegan",
    "Jain vegetarian",
    "Eggetarian",
    "Non vegetarian",
    "Seafood",
    "Mutton",
    "Chicken",
    "Mushroom",
    "Soya & soya products",
  ];

  const oilType = [
    "Sunflower",
    "Olive",
    "Rice Bran",
    "Coconut",
    "Groundnut",
    "Ghee",
  ];

  const saltType = ["Iodised", "Non-Iodised"];

  const milkType = [
    "Packed full cream",
    "Packed toned",
    "Packed double toned",
    "Cow milk",
    "Buffalo milk",
    "Skimmed milk",
  ];

  const milkProducts = ["Curd", "Buttermilk", "Paneer", "Cow milk", "Cheese"];

  const handleFpSubmit = async () => {
    try {
      // Properly format the request data according to API requirements
      const formData = {
        food_preferences: healthProblems,
        likes: fpLikes || "",
        dislikes: fpDislikes || "",
        oil_type: selectedOilTypes,
        oil_intake_per_month: parseFloat(oiPerM) || 0,
        salt_type: healthProblems3,
        salt_inlake: parseInt(siPerM) || 0,
        other_specify_salt: otSalt || "",
        milk_type: healthProblems5,
        milk_products: healthProblems6,
        other_specify_milk: otMilk || "",
        flour_type: healthProblems4, // Added missing flour_type
        other_specify_flour: otFlour || "" // Added missing flour specification
      };
  
      console.log('Submitting food preferences:', formData);
  
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/dietary-preferences/${id}/${foodPrefRecordId}/`,
        {
          method: foodPrefRecordId ? "PUT" : "POST",
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData)
        }
      );
  
      if (!response.ok) {
        const errorData = await response.json();
        console.error('Food preferences error:', errorData);
        throw new Error(errorData.message || 'Failed to update food preferences');
      }
  
      const json = await response.json();
      console.log('Food preferences updated:', json);
  
      setDietPref(json);
      setFoodPrefRecordId(json.id);
  
      setHealthProblems(Array.isArray(json.food_preferences) ? json.food_preferences : []);
      setSelectedOilTypes(Array.isArray(json.oil_type) ? json.oil_type : []);
      setHealthProblems3(Array.isArray(json.salt_type) ? json.salt_type : []);
      setHealthProblems4(Array.isArray(json.flour_type) ? json.flour_type : []);
      setHealthProblems5(Array.isArray(json.milk_type) ? json.milk_type : []);
      setHealthProblems6(Array.isArray(json.milk_products) ? json.milk_products : []);
      
      setFpLikes(json.likes ?? "");
      setFpDislikes(json.dislikes ?? "");
      setOiPerM(json.oil_intake_per_month?.toString() ?? "");
      setSiPerM(json.salt_inlake?.toString() ?? "");
      setOtSalt(json.other_specify_salt ?? "");
      setOtMilk(json.other_specify_milk ?? "");
      setOtFlour(json.other_specify_flour ?? ""); 
  
      // Optional: Show success message
  
    } catch (error) {
      console.error('Error saving food preferences:', error);
      alert('Failed to save food preferences. Please try again.');
    }
  };

  const handleUpdateFoodPref = async (e) => {
    e.preventDefault();
    try {
      const formData = {
        food_preferences: healthProblems,
        likes: fpLikes,
        dislikes: fpDislikes,
        oil_type: selectedOilTypes,
        oil_intake_per_month: oiPerM,
        salt_type: healthProblems3,
        salt_inlake: siPerM,
        other_specity_salt: otSalt,
        milk_type: healthProblems5,
        milk_products: healthProblems6,
        other_specify_milk: otMilk,
      };

      console.log(formData);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/dietary-preferences/${id}/${
          foodPrefRecordId === 0 ? "" : foodPrefRecordId
        }/`,
        {
          method: "PUT",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log("updated surgical history");
        fetchData6();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (surgicalHistory?.length > 0) {
      setSurgery(surgicalHistory[0].surgery);
    }
    console.log(
      surgicalHistory,
      "SURGICAL HISTORY DATA============================================="
    );
  }, [surgicalHistory]);

  const handleOtherInfoSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log(otherInfo);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/other-informations/${id}/`,
        {
          method: "POST",
          body: JSON.stringify(otherInfo),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log("added dietary preference");
        fetchData7();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateOtherInfo = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/other-informations/${id}/${
          otherInfoRecordId === 0 ? "" : `${otherInfoRecordId}/`
        }`,
        {
          method: otherInfoRecordId === 0 ? "POST" : "PUT",
          body: JSON.stringify({
            ...otherInfo,
            water_intack: otherInfo.water_intake, // Fix the field name mismatch
          }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const json = await response.json();
      if (response.ok) {
        console.log("Updated other information");
        fetchData8(); // Refresh the data
      }
    } catch (error) {
      console.log(error);
    }
  };

  function calculateMetrics(weight, height, waist, hip, wUnit, hUnit, gender) {
    // Convert weight and height to metric units if needed
    if (wUnit === "LBS") weight = weight * 0.453592; // Convert lbs to kg
    if (hUnit === "FT/IN") height = height * 0.3048; // Convert ft/in to meters
    if (hUnit === "CM") height = height / 100; // Convert cm to meters

    // Calculate BMI
    const bmi = weight / height ** 2;
    let bmiCategory;
    if (bmi < 18.5) bmiCategory = "Underweight";
    else if (bmi < 24.9) bmiCategory = "Normal weight";
    else if (bmi < 29.9) bmiCategory = "Overweight";
    else if (bmi < 34.9) bmiCategory = "Obese Class 1";
    else if (bmi < 39.9) bmiCategory = "Obese Class 2";
    else bmiCategory = "Obese Class 3";

    // Calculate WHR
    const whr = waist / hip;
    let whrCategory;
    if (whr < 0.8) whrCategory = "Low risk";
    else if (whr < 0.9) whrCategory = "Moderate risk";
    else whrCategory = "High risk";

    let idealWeight;
    if (gender == "FEMALE") {
      // female
      idealWeight = 45.5 + 0.91 * (height * 100 - 152.4);
    } else {
      // male
      idealWeight = 50 + 0.91 * (height * 100 - 152.4);
    }

    // console.log(idealWeight, "ideal");

    return {
      bmi: bmi.toFixed(1) + ` (${bmiCategory})`,
      whr: whr.toFixed(2) + ` (${whrCategory})`,
      idealWeight: `${idealWeight.toFixed(1)} kg`,
    };
  }

  const metrics = calculateMetrics(
    weight,
    height,
    30,
    0.8,
    wUnit,
    hUnit,
    gender
  );

  // Helper Functions
  const getBloodPressureStatus = (systolic, diastolic) => {
    if (systolic < 90 || diastolic < 60) return "Low";
    if (systolic > 120 || diastolic > 80) return "High";
    return "Normal";
  };

  const getBloodSugarStatus = (fasting, postprandial, hba1c) => {
    if (fasting < 70 || postprandial < 140 || hba1c < 5.6) return "Low";
    if (fasting > 99 || postprandial >= 140 || hba1c > 5.6) return "High";
    return "Normal";
  };

  const getKidneyStatus = (creatinine, bun, gfr, sodium, potassium) => {
    // Check for high values
    if (
      creatinine > 1.2 ||
      bun > 20 ||
      gfr > 120 ||
      sodium > 145 ||
      potassium > 5.0
    ) {
      return "High";
    }
    // Check for low values
    if (
      creatinine < 0.6 ||
      bun < 7 ||
      gfr < 90 ||
      sodium < 135 ||
      potassium < 3.5
    ) {
      return "Low";
    }
    // If within normal ranges
    return "Normal";
  };

  const getLiverStatus = (
    alt,
    ast,
    alp,
    bilirubin,
    albumin,
    protein,
    directBilirubin,
    indirectBilirubin
  ) => {
    if (
      alt > 56 ||
      ast > 40 ||
      alp > 147 ||
      bilirubin > 1.2 ||
      albumin > 5.0 ||
      protein > 8.3 ||
      directBilirubin > 0.3 ||
      indirectBilirubin > 0.9
    )
      return "High";
    if (
      alt < 7 ||
      ast < 10 ||
      alp < 44 ||
      bilirubin < 0.1 ||
      albumin < 3.5 ||
      protein < 6.0 ||
      directBilirubin > 0.3 ||
      indirectBilirubin > 0.9
    )
      return "Low";
    return "Normal";
  };

  const getLipidStatus = (cholesterol, ldl, hdl, triglycerides, gender) => {
    const hdlThreshold = gender === "MALE" ? 40 : 50; // Update threshold for HDL based on gender
    if (
      cholesterol >= 200 ||
      ldl >= 100 ||
      hdl < hdlThreshold ||
      triglycerides >= 150
    )
      return "High";
    return "Normal";
  };

  const getCBCStatus = (
    wbc,
    rbc,
    hemoglobin,
    hematocrit,
    platelets,
    mcv,
    mchc,
    gender
  ) => {
    const rbcRange =
      gender === "MALE" ? { min: 4.7, max: 6.1 } : { min: 4.2, max: 5.4 };
    const hemoglobinRange =
      gender === "MALE" ? { min: 13.8, max: 17.2 } : { min: 12.1, max: 15.1 };
    const hematocritRange =
      gender === "MALE" ? { min: 40.7, max: 50.3 } : { min: 36.1, max: 44.3 };

    if (
      wbc > 11000 ||
      rbc > rbcRange.max ||
      hemoglobin > hemoglobinRange.max ||
      hematocrit > hematocritRange.max ||
      platelets > 450000 ||
      mcv > 100 ||
      mchc > 36
    )
      return "High";
    if (
      wbc < 4000 ||
      rbc < rbcRange.min ||
      hemoglobin < hemoglobinRange.min ||
      hematocrit < hematocritRange.min ||
      platelets < 150000 ||
      mcv < 80 ||
      mchc < 32
    )
      return "Low";
    return "Normal";
  };

  const getTemperatureStatus = (temp) => {
    if (temp < 36.1) return "Low";
    if (temp > 37.2) return "High";
    return "Normal";
  };

  const getHeartRateStatus = (rate) => {
    if (rate < 60) return "Low";
    if (rate > 100) return "High";
    return "Normal";
  };

  const getRespiratoryRateStatus = (rate) => {
    if (rate < 12) return "Low";
    if (rate > 20) return "High";
    return "Normal";
  };

  const getOxygenSaturationStatus = (saturation) => {
    if (saturation < 95) return "Low";
    if (saturation > 100) return "High";
    return "Normal";
  };

  // Add state for Direct and Indirect Bilirubin
  const [directBilirubin, setDirectBilirubin] = useState("");
  const [indirectBilirubin, setIndirectBilirubin] = useState("");

  // Add these state variables near the top with other useState declarations
  const [drugNameChoices, setDrugNameChoices] = useState([]);
  const [drugStrengthChoices, setDrugStrengthChoices] = useState([]);
  const [drugFrequencyChoices, setDrugFrequencyChoices] = useState([]);

  // Add this function with other useEffect hooks
  useEffect(() => {
    const fetchDrugChoices = async () => {
      try {
        const [nameRes, strengthRes, frequencyRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_BASE_URL}/api/drug-name-choices/`),
          fetch(`${process.env.REACT_APP_BASE_URL}/api/drug-strength-choices/`),
          fetch(
            `${process.env.REACT_APP_BASE_URL}/api/drug-frequency-choices/`
          ),
        ]);

        const [names, strengths, frequencies] = await Promise.all([
          nameRes.json(),
          strengthRes.json(),
          frequencyRes.json(),
        ]);

        setDrugNameChoices(names);
        setDrugStrengthChoices(strengths);
        setDrugFrequencyChoices(frequencies);
      } catch (error) {
        console.error("Error fetching drug choices:", error);
      }
    };

    fetchDrugChoices();
  }, []);

  const getFoodPreferenceName = (value) => {
    const names = {
      1: "Vegetarian",
      2: "Vegan",
      3: "Jain vegetarian",
      4: "Eggetarian",
      5: "Non vegetarian",
      6: "Seafood",
      7: "Mutton",
      8: "Chicken",
      9: "Mushroom",
      10: "Soya & soya products",
    };
    return names[value];
  };

  const getOilTypeName = (value) => {
    const names = {
      1: "Sunflower",
      2: "Olive",
      3: "Rice bran",
      4: "Coconut",
      5: "Groundnut",
      6: "Ghee",
    };
    return names[value];
  };

  const getSaltTypeName = (value) => {
    const names = {
      1: "Iodised",
      2: "Non-Iodised",
    };
    return names[value] || "";
  };

  const getFlourTypeName = (value) => {
    const names = {
      1: "Wheat",
      2: "Multigrain",
      3: "Mixed",
    };
    return names[value] || "";
  };

  const getMilkTypeName = (value) => {
    const names = {
      1: "Packed full cream",
      2: "Packed toned",
      3: "Packed double toned",
      4: "Cow milk",
      5: "Buffalo milk",
      6: "Skimmed milk",
    };
    return names[value] || "";
  };

  const getMilkProductName = (value) => {
    const names = {
      1: "Curd",
      2: "Buttermilk",
      3: "Paneer",
      4: "Cow milk",
      5: "Cheese",
    };
    return names[value] || "";
  };

  // Add state for ICD codes
  const [icdCodes, setIcdCodes] = useState([]);

  useEffect(() => {
    if (dietPref && Object.keys(dietPref).length > 0) {
      setHealthProblems(dietPref.food_preferences || []);
      setSelectedOilTypes(dietPref.oil_type || []);
      setHealthProblems3(dietPref.salt_type || []);
      setHealthProblems4(dietPref.flour_type || []);
      setHealthProblems5(dietPref.milk_type || []);
      setHealthProblems6(dietPref.milk_products || []);
      setFpLikes(dietPref.likes || "");
      setFpDislikes(dietPref.dislikes || "");
      setOiPerM(dietPref.oil_intake_per_month || "");
      setSiPerM(dietPref.salt_inlake || "");
      setOtSalt(dietPref.other_specify_salt || "");
      setOtMilk(dietPref.other_specify_milk || "");
      setOtFlour(dietPref.other_specify_flour || "");
    }
  }, [dietPref]);

  const [showSuggestions, setShowSuggestions] = useState(false);

  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const MAX_SUGGESTIONS = 10; 

  //////

  const handleSearch = (value) => {
    setSearchTerm(value);
  
    if (!value.trim()) {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
      return;
    }
  
    let matches = complaintOptions.filter(option => {
      const description = (option.description || option.long_description || '').toLowerCase();
      const searchLower = value.toLowerCase();
      return description.includes(searchLower);
    });
  
    if (matches.length === 0) {
      matches = complaintOptions.filter(option => 
        option.code.toLowerCase().includes(value.toLowerCase())
      );
    }
  
    matches.sort((a, b) => {
      const aDesc = (a.description || a.long_description || '').toLowerCase();
      const bDesc = (b.description || b.long_description || '').toLowerCase();
      const searchLower = value.toLowerCase();
      
      const aStartsWith = aDesc.startsWith(searchLower);
      const bStartsWith = bDesc.startsWith(searchLower);
      
      if (aStartsWith && !bStartsWith) return -1;
      if (!aStartsWith && bStartsWith) return 1;
      return 0;
    });
  
    setFilteredSuggestions(matches.slice(0, MAX_SUGGESTIONS));
    setShowSuggestions(true);
  };

  const handleSelectSuggestion = (suggestion) => {
    setDiagnosis(suggestion.id.toString());
    setComplaintCode(suggestion.id.toString());
    setSelectedDescription(suggestion.long_description || "");
    setSearchTerm(suggestion.code);
    setShowSuggestions(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".relative")) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  //dietary recall

  const [mealEntries, setMealEntries] = useState([
    {
      id: 1,
      activity: "Pre-Breakfast",
      duration: "08:00",
      dishes: [
        {
          name: "Dry Fruits",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        },
      ],
    },
    {
      id: 2,
      activity: "Breakfast",
      duration: "09:00",
      dishes: [{ name: "Milk", description: "" }],
    },
    {
      id: 3,
      activity: "Leaving Home from Breakfast",
      duration: "09:00",
      dishes: [
        {
          name: "Dry Fruits",
          description: "Lorem ipsum dolor sit amet, consectetur",
        },
      ],
    },
  ]);

  const [selectedMeal, setSelectedMeal] = useState(null);

  const handleAddMeal = () => {
    const newMeal = {
      id: mealEntries.length + 1,
      activity: "",
      duration: "",
      dishes: [],
    };
    setMealEntries([...mealEntries, newMeal]);
  };

  const handleAddDish = (mealId) => {
    const updatedEntries = mealEntries.map((meal) => {
      if (meal.id === mealId) {
        return {
          ...meal,
          dishes: [...meal.dishes, { name: "Select Dish", description: "" }],
        };
      }
      return meal;
    });
    setMealEntries(updatedEntries);
  };

  return (
    <div className="gsMain">
      <Toaster/>
      <button
        className="edit-all-btn"
        onClick={() => {
          if (globalEdit) {
            handleGlobalSave();
          } else {
            handleGlobalEdit();
          }
        }}
        style={{
          backgroundColor: globalEdit ? "#f23d76" : "#393939",
          color: "white",
          zIndex: 1000,
          padding: "1px 20px",
          border: "none",
          borderRadius: "28px",
          width: "167px",
          height: "45px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "15px",
          /* font-weight: bold; */
          transition: "background-color 0.3s",
          textAlign: "center",
          filter: globalEdit
            ? "drop-shadow(0px 0px 6px #f23d76)"
            : "drop-shadow(0px 0px 6px #393939)",
        }}
      >
        {globalEdit ? "Save changes" : "Edit this section"}
      </button>

      {/* <button
        id="exportBtnID"
        className="exportBtn"
        onClick={handleExport}
      >
        Export Assessment
      </button> */}
      <div className="ccm goalSet">
        <div className="gs">
          <div className="ccmTop">
            <h1>Personal Info</h1>
          </div>
          <form
            className="slide"
            style={{ border: edit ? "" : "1px solid #F23D76" }}
            onSubmit={updatePersonalInfo}
          >
            <div className="slideCont">
              <p>
                Name:
                {edit ? (
                  <b>{name}</b>
                ) : (
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                )}
              </p>
              <p>
                Birthdate:
                {edit ? (
                  <b>{birthdate}</b>
                ) : (
                  <input
                    type="date"
                    value={birthdate}
                    onChange={(e) => {
                      setBirthdate(e.target.value);
                      calAge(e.target.value);
                    }}
                  />
                )}
              </p>
              <p>
                Gender:
                {edit ? (
                  <b>{gender}</b>
                ) : (
                  <select
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <option value="MALE">Male (M)</option>
                    <option value="FEMALE">Female (F)</option>
                    <option value="OTHER">Other (O)</option>
                  </select>
                )}
              </p>
            </div>
            <div className="slideCont">
              <p>
                State:
                {edit ? (
                  <b>{allStates?.states?.find((s) => s.id === stId)?.name}</b>
                ) : (
                  <select
                    value={allStates?.states?.find((s) => s.id === stId)?.name}
                    onChange={(e) => {
                      setState(e.target.value);
                      const selectedOption =
                        e.target.options[e.target.selectedIndex];
                      const stateId = selectedOption.getAttribute("data-id");
                      setStId(stateId);
                      fetchCity();
                    }}
                  >
                    {allStates?.states?.map((as, index) => (
                      <option value={as.name} key={index} data-id={as.id}>
                        {as.name}
                      </option>
                    ))}
                  </select>
                )}
              </p>
              <p>
                City:
                {edit ? (
                  <b>{allCities?.cities?.find((c) => c.id === ctId)?.name}</b>
                ) : (
                  <select
                    value={allCities?.cities?.find((c) => c.id === ctId)?.name}
                    onChange={(e) => {
                      setCity(e.target.value);
                      const selectedOption =
                        e.target.options[e.target.selectedIndex];
                      const cityId = selectedOption.getAttribute("data-id");
                      setCtId(cityId);
                    }}
                  >
                    {allCities?.cities?.map((as, index) => (
                      <option value={as.name} key={index} data-id={as.id}>
                        {as.name}
                      </option>
                    ))}
                  </select>
                )}
              </p>
              <p>
                Blood Group:
                {edit ? (
                  <b>{bloodGroup}</b>
                ) : (
                  <select
                    value={bloodGroup}
                    onChange={(e) => setBloodGroup(e.target.value)}
                  >
                    <option value="A+">A+</option>
                    <option value="A-">A-</option>
                    <option value="B+">B+</option>
                    <option value="B-">B-</option>
                    <option value="AB+">AB+</option>
                    <option value="AB-">AB-</option>
                    <option value="O+">O+</option>
                    <option value="O-">O-</option>
                  </select>
                )}
              </p>
            </div>
            <div className="slideCont">
              <p>
                Weight:
                {edit ? (
                  <b>{weight + wUnit}</b>
                ) : (
                  <div>
                    <label>
                      <input
                        type="radio"
                        name="weightUnit"
                        value="LBS"
                        onChange={(e) => setWUnit(e.target.value)}
                      />{" "}
                      Lbs
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="weightUnit"
                        value="KG"
                        defaultChecked
                        onChange={(e) => setWUnit(e.target.value)}
                      />{" "}
                      Kg
                    </label>
                    <input
                      type="number"
                      value={weight}
                      onChange={(e) => setWeight(e.target.value)}
                    />
                  </div>
                )}
              </p>
              <p>
                Height:
                {edit ? (
                  <b>{height + hUnit}</b>
                ) : (
                  <div>
                    <label>
                      <input
                        type="radio"
                        name="heightUnit"
                        value="FT/IN"
                        onChange={(e) => setHUnit(e.target.value)}
                      />{" "}
                      Ft/In
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="heightUnit"
                        value="CM"
                        defaultChecked
                        onChange={(e) => setHUnit(e.target.value)}
                      />{" "}
                      Cm
                    </label>
                    <input
                      type="number"
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                    />
                  </div>
                )}
              </p>
            </div>
            <div className="slideCont">
              <p>
                Relationship Status:
                {edit ? (
                  <b>{relationshipStatus || "Not Specified"}</b>
                ) : (
                  <div>
                    <label>
                      <input
                        type="radio"
                        name="relationshipStatus"
                        value="Married"
                        onChange={(e) => setRelationshipStatus("MARRIED")}
                      />{" "}
                      Married
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="relationshipStatus"
                        value="Unmarried"
                        onChange={(e) => setRelationshipStatus("UNMARRIED")}
                      />{" "}
                      Unmarried
                    </label>
                  </div>
                )}
              </p>
            </div>
            <div className="slideCont">
              <p>
                BMI: <b className="bmi">{metrics.bmi}</b>
              </p>
              <p>
                Ideal Weight: <b className="iwr">{metrics.idealWeight}</b>
              </p>
            </div>
          </form>
        </div>
      </div>
      <div className="ccm goalSet">
        <div className="gs">
          <div className="ccmTop">
            <h1>Communication Info</h1>
          </div>
          <div className="slide">
            <div className="slideCont">
              <p>
                WA Phone Number:
                <input
                  type="text"
                  readOnly={edit2}
                  value={wa_phone_number}
                  onChange={(e) => setWa_phone_number(e.target.value)}
                  style={{ border: edit2 ? "none" : "1px solid #919191" }}
                />
              </p>
              <p>
                Alternate Phone Number:
                <input
                  type="text"
                  readOnly={edit2}
                  value={alternate_phone_number}
                  onChange={(e) => setAlternate_phone_number(e.target.value)}
                  style={{ border: edit2 ? "none" : "1px solid #919191" }}
                />
              </p>
            </div>
            <p id="email_id_error" style={{ display: "none", color: "red" }}>
              Please enter a valid email address
            </p>
            <div className="slideCont">
              <p>
                Email ID:
                <input
                  type="text"
                  readOnly={edit2}
                  value={email_id}
                  onChange={(e) => setEmail_id(e.target.value)}
                  style={{ border: edit2 ? "none" : "1px solid #919191" }}
                />
              </p>
            </div>
            <div className="slideCont">
              <div className="alg algDesc">
                <p>Address :</p>
                <textarea
                  readOnly={edit2}
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  style={{ border: edit2 ? "none" : "1px solid #707070" }}
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d2lc">
        <div className="vitals ccm">
          <div className="ccmTop">
            <h1>Vitals</h1>
            <div className="udb"></div>
          </div>
          {vitals?.vitals ? (
            <>
              <div className="d2Links">
                {vitals.available_dates?.reverse().map((vat, index) => (
                  <div
                    className="vtDate"
                    onClick={() => fetchData10(vat)} // Pass vat directly
                    key={index}
                    id={vat}
                    style={
                      vitals?.vitals?.updated_at.split("T")[0] === vat
                        ? { backgroundColor: "rgb(64, 64, 64)", color: "white" }
                        : {}
                    }
                  >
                    {vat}
                  </div>
                ))}
              </div>
              <form className="allVits">
                <div className="slide vit">
                  <img src={bloodPressure} alt="bloodPressure" />
                  <div className="vitDesc">
                    <p>
                      <b>Blood Pressure: </b>
                      <span
                        className={getBloodPressureStatus(
                          vitals.vitals.blood_pressure[0].systolic,
                          vitals.vitals.blood_pressure[0].diastolic
                        ).toLowerCase()}
                      >
                        {getBloodPressureStatus(
                          vitals.vitals.blood_pressure[0].systolic,
                          vitals.vitals.blood_pressure[0].diastolic
                        )}
                      </span>
                    </p>
                    <p>
                      Systolic:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={sys}
                            onChange={(e) => handleSysChange(e)}
                          />
                        ) : (
                          <b>{vitals.vitals.blood_pressure[0].systolic}</b>
                        )}
                        mmHg
                      </span>
                    </p>
                    <p>
                      Diastolic:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={dia}
                            onChange={(e) => handleDiaChange(e)}
                          />
                        ) : (
                          <b>{vitals.vitals.blood_pressure[0].diastolic}</b>
                        )}
                        mmHg
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  <img src={bloodSugar} alt="bloodSugar" />
                  <div className="vitDesc">
                    <p>
                      <b>Blood Sugar: </b>
                      <span
                        className={getBloodSugarStatus(
                          vitals.vitals.blood_sugar[0].fasting_blood_glucose,
                          vitals.vitals.blood_sugar[0]
                            .postprandial_blood_glucose,
                          vitals.vitals.blood_sugar[0].hemoglobin_A1c
                        ).toLowerCase()}
                      >
                        {getBloodSugarStatus(
                          vitals.vitals.blood_sugar[0].fasting_blood_glucose,
                          vitals.vitals.blood_sugar[0]
                            .postprandial_blood_glucose,
                          vitals.vitals.blood_sugar[0].hemoglobin_A1c
                        )}
                      </span>
                    </p>
                    <p>
                      Fasting Blood Glucose:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={fastGlucose}
                            onChange={(e) => handleFastGlucoseChange(e)}
                          />
                        ) : (
                          <b>
                            {vitals.vitals.blood_sugar[0].fasting_blood_glucose}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Postprandial Blood Glucose:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={postGlucose}
                            onChange={(e) => handlePostGlucoseChange(e)}
                          />
                        ) : (
                          <b>
                            {
                              vitals.vitals.blood_sugar[0]
                                .postprandial_blood_glucose
                            }
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Hemoglobin A1c:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={hemoglobinA1c}
                            onChange={(e) => handleHemoglobinA1cChange(e)}
                          />
                        ) : (
                          <b>{vitals.vitals.blood_sugar[0].hemoglobin_A1c}</b>
                        )}
                        %
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  <img src={kidneyTests} alt="kidneyTests" />
                  <div className="vitDesc">
                    <p>
                      <b>Kidney Function Tests: </b>
                      <span
                        className={getKidneyStatus(
                          vitals.vitals.kidney_function[0].serum_creatinine,
                          vitals.vitals.kidney_function[0].blood_urea_nitrogen,
                          vitals.vitals.kidney_function[0].estimated_GFR,
                          vitals.vitals.kidney_function[0].electrolytes_sodium,
                          vitals.vitals.kidney_function[0]
                            .electrolytes_potassium
                        ).toLowerCase()}
                      >
                        {getKidneyStatus(
                          vitals.vitals.kidney_function[0].serum_creatinine,
                          vitals.vitals.kidney_function[0].blood_urea_nitrogen,
                          vitals.vitals.kidney_function[0].estimated_GFR,
                          vitals.vitals.kidney_function[0].electrolytes_sodium,
                          vitals.vitals.kidney_function[0]
                            .electrolytes_potassium
                        )}
                      </span>
                    </p>
                    <p>
                      Serum Creatinine:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={serumCr}
                            onChange={handleSerumCrChange}
                          />
                        ) : (
                          <b>
                            {vitals.vitals.kidney_function[0].serum_creatinine}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Blood Urea Nitrogen:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={bun}
                            onChange={handleBunChange}
                          />
                        ) : (
                          <b>
                            {
                              vitals.vitals.kidney_function[0]
                                .blood_urea_nitrogen
                            }
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Estimated GFR:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={eGFR}
                            onChange={handleEGFRChange}
                          />
                        ) : (
                          <b>
                            {vitals.vitals.kidney_function[0].estimated_GFR}
                          </b>
                        )}
                        mL/min/1.73 m²
                      </span>
                    </p>
                    <p>
                      Electrolytes: Sodium:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={sodium}
                            onChange={handleSodiumChange}
                          />
                        ) : (
                          <b>
                            {
                              vitals.vitals.kidney_function[0]
                                .electrolytes_sodium
                            }
                          </b>
                        )}
                        mmol/L
                      </span>
                    </p>
                    <p>
                      Electrolytes: Potassium:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={potassium}
                            onChange={handlePotassiumChange}
                          />
                        ) : (
                          <b>
                            {
                              vitals.vitals.kidney_function[0]
                                .electrolytes_potassium
                            }
                          </b>
                        )}
                        mmol/L
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  <img src={liverTests} alt="liverTests" />
                  <div className="vitDesc">
                    <p>
                      <b>Liver Function Tests: </b>
                      <span
                        className={getLiverStatus(
                          vitals.vitals.liver_function[0]
                            .alanine_aminotransferase,
                          vitals.vitals.liver_function[0]
                            .aspartate_aminotransferase,
                          vitals.vitals.liver_function[0].alkaline_phosphatase,
                          vitals.vitals.liver_function[0].total_bilirubin,
                          vitals.vitals.liver_function[0].albumin,
                          vitals.vitals.liver_function[0].total_protein,
                          vitals.vitals.liver_function[0].direct_bilirubin,
                          vitals.vitals.liver_function[0].indirect_bilirubin
                        ).toLowerCase()}
                      >
                        {getLiverStatus(
                          vitals.vitals.liver_function[0]
                            .alanine_aminotransferase,
                          vitals.vitals.liver_function[0]
                            .aspartate_aminotransferase,
                          vitals.vitals.liver_function[0].alkaline_phosphatase,
                          vitals.vitals.liver_function[0].total_bilirubin,
                          vitals.vitals.liver_function[0].albumin,
                          vitals.vitals.liver_function[0].total_protein,
                          vitals.vitals.liver_function[0].direct_bilirubin,
                          vitals.vitals.liver_function[0].indirect_bilirubin
                        )}
                      </span>
                    </p>
                    <p>
                      Alanine Aminotransferase:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={alt}
                            onChange={handleAltChange}
                          />
                        ) : (
                          <b>
                            {
                              vitals.vitals.liver_function[0]
                                .alanine_aminotransferase
                            }
                          </b>
                        )}
                        U/L
                      </span>
                    </p>
                    <p>
                      Aspartate Aminotransferase:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={ast}
                            onChange={handleAstChange}
                          />
                        ) : (
                          <b>
                            {
                              vitals.vitals.liver_function[0]
                                .aspartate_aminotransferase
                            }
                          </b>
                        )}
                        U/L
                      </span>
                    </p>
                    <p>
                      Alkaline Phosphatase:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={alp}
                            onChange={handleAlpChange}
                          />
                        ) : (
                          <b>
                            {
                              vitals.vitals.liver_function[0]
                                .alkaline_phosphatase
                            }
                          </b>
                        )}
                        U/L
                      </span>
                    </p>
                    <p>
                      Total Bilirubin:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={bilirubin}
                            onChange={handleBilirubinChange}
                          />
                        ) : (
                          <b>
                            {vitals.vitals.liver_function[0].total_bilirubin}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Albumin:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={albumin}
                            onChange={handleAlbuminChange}
                          />
                        ) : (
                          <b>{vitals.vitals.liver_function[0].albumin}</b>
                        )}
                        g/dL
                      </span>
                    </p>
                    <p>
                      Total Protein:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={protein}
                            onChange={handleProteinChange}
                          />
                        ) : (
                          <b>{vitals.vitals.liver_function[0].total_protein}</b>
                        )}
                        g/dL
                      </span>
                    </p>
                    <p>
                      <b>Direct Bilirubin: </b>
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={directBilirubin}
                            onChange={(e) => setDirectBilirubin(e.target.value)}
                          />
                        ) : (
                          <b>
                            {vitals.vitals.liver_function[0].direct_bilirubin}
                          </b>
                        )}
                        mg/dL (0-0.3)
                      </span>
                    </p>
                    <p>
                      <b>Indirect Bilirubin: </b>
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={indirectBilirubin}
                            onChange={(e) =>
                              setIndirectBilirubin(e.target.value)
                            }
                          />
                        ) : (
                          <b>
                            {vitals.vitals.liver_function[0].indirect_bilirubin}
                          </b>
                        )}
                        mg/dL (0.1-0.9)
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  <img src={lipidProf} alt="lipidProfile" />
                  <div className="vitDesc">
                    <p>
                      <b>Lipid Profile: </b>
                      <span
                        className={getLipidStatus(
                          vitals.vitals.lipid_profile[0].total_cholesterol,
                          vitals.vitals.lipid_profile[0].LDL_cholesterol,
                          vitals.vitals.lipid_profile[0].HDL_cholesterol,
                          vitals.vitals.lipid_profile[0].triglycerides,
                          gender
                        ).toLowerCase()}
                      >
                        {getLipidStatus(
                          vitals.vitals.lipid_profile[0].total_cholesterol,
                          vitals.vitals.lipid_profile[0].LDL_cholesterol,
                          vitals.vitals.lipid_profile[0].HDL_cholesterol,
                          vitals.vitals.lipid_profile[0].triglycerides,
                          gender
                        )}
                      </span>
                    </p>
                    <p>
                      Total Cholesterol:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={cholesterol}
                            onChange={handleCholesterolChange}
                          />
                        ) : (
                          <b>
                            {vitals.vitals.lipid_profile[0].total_cholesterol}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      LDL Cholesterol:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={ldl}
                            onChange={handleLdlChange}
                          />
                        ) : (
                          <b>
                            {vitals.vitals.lipid_profile[0].LDL_cholesterol}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      HDL Cholesterol:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={hdl}
                            onChange={handleHdlChange}
                          />
                        ) : (
                          <b>
                            {vitals.vitals.lipid_profile[0].HDL_cholesterol}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Triglycerides:{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={triglycerides}
                            onChange={handleTriglyceridesChange}
                          />
                        ) : (
                          <b>{vitals.vitals.lipid_profile[0].triglycerides}</b>
                        )}
                        mg/dL
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  <img src={bloodCount} alt="cbc" />
                  <div className="vitDesc">
                    <p>
                      <b>Complete Blood Count (CBC): </b>
                      <span
                        className={getCBCStatus(
                          vitals.vitals.cbc[0].white_blood_cells,
                          vitals.vitals.cbc[0].red_blood_cells,
                          vitals.vitals.cbc[0].hemoglobin,
                          vitals.vitals.cbc[0].hematocrit,
                          vitals.vitals.cbc[0].platelet_count,
                          vitals.vitals.cbc[0].mean_corpuscular_volume,
                          vitals.vitals.cbc[0]
                            .mean_corpuscular_hemoglobin_concentration,
                          "MALE"
                        ).toLowerCase()}
                      >
                        {getCBCStatus(
                          vitals.vitals.cbc[0].white_blood_cells,
                          vitals.vitals.cbc[0].red_blood_cells,
                          vitals.vitals.cbc[0].hemoglobin,
                          vitals.vitals.cbc[0].hematocrit,
                          vitals.vitals.cbc[0].platelet_count,
                          vitals.vitals.cbc[0].mean_corpuscular_volume,
                          vitals.vitals.cbc[0]
                            .mean_corpuscular_hemoglobin_concentration,
                          "MALE"
                        )}
                      </span>
                    </p>
                    <p>
                      White Blood Cells:{" "}
                      <span>
                        <b>
                          {globalEdit ? (
                            <input
                              type="number"
                              value={wbc}
                              onChange={handleWbcChange}
                            />
                          ) : (
                            vitals.vitals.cbc[0].white_blood_cells
                          )}
                        </b>{" "}
                        ×10³/µL
                      </span>
                    </p>
                    <p>
                      Red Blood Cells:{" "}
                      <span>
                        <b>
                          {globalEdit ? (
                            <input
                              type="number"
                              value={rbc}
                              onChange={handleRbcChange}
                            />
                          ) : (
                            vitals.vitals.cbc[0].red_blood_cells
                          )}
                        </b>{" "}
                        million cells/µL
                      </span>
                    </p>
                    <p>
                      Hemoglobin:{" "}
                      <span>
                        <b>
                          {globalEdit ? (
                            <input
                              type="number"
                              value={hemoglobin}
                              onChange={handleHemoglobinChange}
                            />
                          ) : (
                            vitals.vitals.cbc[0].hemoglobin
                          )}
                        </b>{" "}
                        g/dL
                      </span>
                    </p>
                    <p>
                      Hematocrit:{" "}
                      <span>
                        <b>
                          {globalEdit ? (
                            <input
                              type="number"
                              value={hematocrit}
                              onChange={handleHematocritChange}
                            />
                          ) : (
                            vitals.vitals.cbc[0].hematocrit
                          )}
                        </b>{" "}
                        %
                      </span>
                    </p>
                    <p>
                      Platelet Count:{" "}
                      <span>
                        <b>
                          {globalEdit ? (
                            <input
                              type="number"
                              value={platelets}
                              onChange={handlePlateletsChange}
                            />
                          ) : (
                            vitals.vitals.cbc[0].platelet_count
                          )}
                        </b>{" "}
                        ×10³/µL
                      </span>
                    </p>
                    <p>
                      Mean Corpuscular Volume:{" "}
                      <span>
                        <b>
                          {globalEdit ? (
                            <input
                              type="number"
                              value={mcv}
                              onChange={handleMcvChange}
                            />
                          ) : (
                            vitals.vitals.cbc[0].mean_corpuscular_volume
                          )}
                        </b>{" "}
                        ×10³/µL
                      </span>
                    </p>
                    <p>
                      Mean Corpuscular Hemoglobin Concentration:{" "}
                      <span>
                        <b>
                          {globalEdit ? (
                            <input
                              type="number"
                              value={mchc}
                              onChange={handleMchcChange}
                            />
                          ) : (
                            vitals.vitals.cbc[0]
                              .mean_corpuscular_hemoglobin_concentration
                          )}
                        </b>{" "}
                        ×10³/µL
                      </span>
                    </p>
                    <p>
                      Mean Corpuscular Hemoglobin (pg):{" "}
                      <span>
                        {globalEdit ? (
                          <input
                            type="number"
                            value={mchcpg} // Assuming you have a state for MCHC
                            onChange={handleMchcpgChange} // Assuming you have a handler for MCHC
                          />
                        ) : (
                          <b>
                            {vitals.vitals.cbc[0].mean_corpuscular_volume_pg}
                          </b>
                        )}
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  <img src={bodyTemp} alt="bodyTemperature" />
                  <div className="vitDesc">
                    <p>
                      <b>Body Temperature: </b>
                      <span
                        className={getTemperatureStatus(
                          vitals.vitals.body_temperature[0].body_temperature
                        ).toLowerCase()}
                      >
                        {getTemperatureStatus(
                          vitals.vitals.body_temperature[0].body_temperature
                        )}
                      </span>
                    </p>
                    <p>
                      Body Temperature:{" "}
                      <span>
                        <b>
                          {globalEdit ? (
                            <input
                              type="number"
                              value={temp}
                              onChange={handleTempChange}
                            />
                          ) : (
                            vitals.vitals.body_temperature[0].body_temperature
                          )}
                        </b>{" "}
                        °C
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  <img src={heartRate} alt="heartRate" />
                  <div className="vitDesc">
                    <p>
                      <b>Heart Rate (Pulse): </b>
                      <span
                        className={getHeartRateStatus(
                          vitals.vitals.heart_rate[0].heart_rate
                        ).toLowerCase()}
                      >
                        {getHeartRateStatus(
                          vitals.vitals.heart_rate[0].heart_rate
                        )}
                      </span>
                    </p>
                    <p>
                      Heart Rate:{" "}
                      <span>
                        <b>
                          {globalEdit ? (
                            <input
                              type="number"
                              value={hr}
                              onChange={handleHrChange}
                            />
                          ) : (
                            vitals.vitals.heart_rate[0].heart_rate
                          )}
                        </b>{" "}
                        bpm
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  <img src={respRate} alt="respiratoryRate" />
                  <div className="vitDesc">
                    <p>
                      <b>Respiratory Rate: </b>
                      <span
                        className={getRespiratoryRateStatus(
                          vitals.vitals.respiratory_rate[0].respiratory_rate
                        ).toLowerCase()}
                      >
                        {getRespiratoryRateStatus(
                          vitals.vitals.respiratory_rate[0].respiratory_rate
                        )}
                      </span>
                    </p>
                    <p>
                      Respiratory Rate:{" "}
                      <span>
                        <b>
                          {globalEdit ? (
                            <input
                              type="number"
                              value={rr}
                              onChange={handleRrChange}
                            />
                          ) : (
                            vitals.vitals.respiratory_rate[0].respiratory_rate
                          )}
                        </b>{" "}
                        breaths per minute
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  <img src={oxSat} alt="oxygenSaturation" />
                  <div className="vitDesc">
                    <p>
                      <b>Oxygen Saturation (SpO2): </b>
                      <span
                        className={getOxygenSaturationStatus(
                          vitals.vitals.oxygen_saturation[0].oxygen_saturation
                        ).toLowerCase()}
                      >
                        {getOxygenSaturationStatus(
                          vitals.vitals.oxygen_saturation[0].oxygen_saturation
                        )}
                      </span>
                    </p>
                    <p>
                      Oxygen Saturation:{" "}
                      <span>
                        <b>
                          {globalEdit ? (
                            <input
                              type="number"
                              value={o2Sat}
                              onChange={handleO2SatChange}
                            />
                          ) : (
                            vitals.vitals.oxygen_saturation[0].oxygen_saturation
                          )}
                        </b>{" "}
                        %
                      </span>
                    </p>
                  </div>
                </div>
              </form>
            </>
          ) : (
            <p>No vitals data found</p>
          )}
        </div>
      </div>
      <div className="d2lc">
        <div className="ccmMain">
          <div className="ccm">
            <div className="ccmTop">
              <h1>Chief Complaints</h1>
              <div className="udb">
                {/* <p>Last Updated : </p>
                  <p>30 July 2024</p> */}
                <button onClick={() => setCcAddNew(!ccAddNew)}>
                  {ccAddNew ? "Cancel" : "Add New"}
                </button>
              </div>
            </div>
            <div className="sliderMain">
              <div className="sm cms">
                <div className="slider">
                  {chiefComp.length === 0 && (
                    <p className="noSur">
                      {ccAddNew ? null : "No chief complaints"}
                    </p>
                  )}

                  {ccAddNew && (
                    <form className="slide" onSubmit={handleNewCc}>
                      <button type="submit">Save</button>

                      <div className="slideCont">
                        <p>
                          Chief Complaint:{" "}
                          <>
                        <div className="relative w-full">
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => handleSearch(e.target.value)}
    onFocus={() => setShowSuggestions(true)}
    placeholder="Search by condition or symptoms..."
    className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-500"
  />

  {showSuggestions && filteredSuggestions.length > 0 && (
    <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
      {filteredSuggestions.map((suggestion) => (
        <div
          key={suggestion.id}
          className="p-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => handleSelectSuggestion(suggestion)}
        >
          <div className="text-sm text-gray-800">
            {suggestion.description || suggestion.long_description}
          </div>
          <div className="text-xs text-gray-500">Code: {suggestion.code}</div>
        </div>
      ))}
    </div>
  )}
</div>

                           {selectedDescription && (
    <p className="complaint-description italic text-sm text-gray-600 mt-1">
      {selectedDescription}
    </p>
  )}
                          </>
                        </p>
                      </div>

                      <div className="slideCont">
                        <p>
                          Ongoing:{" "}
                          <b>
                            <input
                              className="border-2 border-gray-300 rounded-md p-1"
                              type="text"
                              value={ongoing}
                              onChange={handleOngoingChange}
                            />
                          </b>
                        </p>
                        <p>
                          On Medication:{" "}
                          <b>
                            <input
                              className="border-2 border-gray-300 rounded-md p-1"
                              type="text"
                              value={onMedication}
                              onChange={handleOnMedicationChange}
                            />
                          </b>
                        </p>
                        <p>
                          Well Managed:{" "}
                          <b>
                            <input
                              className="border-2 border-gray-300 rounded-md p-1"
                              type="text"
                              value={wellManaged}
                              onChange={handleWellManagedChange}
                            />
                          </b>
                        </p>
                      </div>

                      <div className="slideCont">
                        <p>
                          Since When:{" "}
                          <b>
                            <input
                              className="border-2 border-gray-300 rounded-md p-1"
                              type="date"
                              value={sinceDate}
                              onChange={handleSinceDateChange}
                            />
                          </b>
                        </p>
                      </div>

                      <div className="slideCont">
                        <p>
                          Description:{" "}
                          <i>
                            <input
                              className="chief--comp--desc"
                              type="text"
                              value={description}
                              onChange={handleDescriptionChange}
                            />
                          </i>
                        </p>
                      </div>
                    </form>
                  )}

                  {chiefComp.map((cc, index) => (
                    ///////////////

                    <form
                      className="slide"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleUpdateCc(e, cc.id);
                      }}
                      key={cc.id}
                    >
                      <button
                        type="submit"
                        onClick={(e) => {
                          if (editIndex === cc.id) {
                            // If in edit mode, let form submission handle the save
                          } else {
                            e.preventDefault();
                            handleEditClickCc(cc.id, cc);
                          }
                        }}
                        className="submit-button"
                      >
                        {editIndex === cc.id ? "Save" : "Edit"}
                      </button>

                      <div className="slideCont">
                        <p>
                          Chief Complaint:{" "}
                          {editIndex === cc.id ? (
                            <>
    <div className="relative w-full">
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => handleSearch(e.target.value)}
    onFocus={() => setShowSuggestions(true)}
    placeholder="Search by condition or symptoms..."
    className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-500"
  />

  {showSuggestions && filteredSuggestions.length > 0 && (
    <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
      {filteredSuggestions.map((suggestion) => (
        <div
          key={suggestion.id}
          className="p-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => handleSelectSuggestion(suggestion)}
        >
          <div className="text-sm text-gray-800">
            {suggestion.description || suggestion.long_description}
          </div>
          <div className="text-xs text-gray-500">
            Code: {suggestion.code}
          </div>
          <div className="text-sm text-gray-500">
           {suggestion.description}
          </div>
        </div>
      ))}
    </div>
  )}
</div>

 {selectedDescription && (
    <p className="complaint-description italic text-sm text-gray-600 mt-1">
      {selectedDescription}
    </p>
  )}
                            </>
                          ) : (
                            <>
                              <b>
                                {
                                  complaintOptions.find(
                                    (opt) =>
                                      opt.id === parseInt(cc.complaint_code)
                                  )?.code
                                }
                              </b>
                              <p className="saved-complaint-details">
                                <span className="complaint-description">
                                  {
                                    complaintOptions.find(
                                      (opt) =>
                                        opt.id === parseInt(cc.complaint_code)
                                    )?.long_description
                                  }
                                </span>
                              </p>
                            </>
                          )}
                        </p>
                      </div>

                      <div className="slideCont">
                        <p>
                          Ongoing:{" "}
                          {editIndex === cc.id ? (
                            <input
                              type="text"
                              value={ongoing}
                              onChange={(e) => setOngoing(e.target.value)}
                              className="p-2 border rounded"
                            />
                          ) : (
                            <b>{cc.ongoing}</b>
                          )}
                        </p>
                        <p>
                          On Medication:{" "}
                          {editIndex === cc.id ? (
                            <input
                              type="text"
                              value={onMedication}
                              onChange={(e) => setOnMedication(e.target.value)}
                              className="p-2 border rounded"
                            />
                          ) : (
                            <b>{cc.on_medication}</b>
                          )}
                        </p>
                        <p>
                          Well Managed:{" "}
                          {editIndex === cc.id ? (
                            <input
                              type="text"
                              value={wellManaged}
                              onChange={(e) => setWellManaged(e.target.value)}
                              className="p-2 border rounded"
                            />
                          ) : (
                            <b>{cc.well_managed}</b>
                          )}
                        </p>
                      </div>

                      <div className="slideCont">
                        <p>
                          Since When:{" "}
                          {editIndex === cc.id ? (
                            <input
                              type="date"
                              value={sinceDate}
                              onChange={(e) => setSinceDate(e.target.value)}
                              className="p-2 border rounded"
                            />
                          ) : (
                            <b>{cc.since_date}</b>
                          )}
                        </p>
                        <p>
                          Duration: <b>{cc.duration}</b>
                        </p>
                      </div>

                      <div className="slideCont">
                        <p>
                          Description:{" "}
                          {editIndex === cc.id ? (
                            <input
                              type="text"
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                              className="p-2 border rounded"
                            />
                          ) : (
                            <i>{cc.description}</i>
                          )}
                        </p>
                      </div>
                    </form>

                    ////////////////////
                  ))}
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d2lc">
        <div className="ccmMain">
          <div className="ccm">
            <div className="ccmTop">
              <h1>Medical History</h1>
              <div className="udb">
                <button
                 onClick={() => {
                  setMedicalHistoryAddNew(!medicalHistoryAddNew);
                  if (!medicalHistoryAddNew) {
                    clearMedicalHistoryForm();
                  }
                }}>
                  {medicalHistoryAddNew ? "Cancel" : "Add New"}
                </button>
              </div>
            </div>
            <div className="sliderMain">
              <div className="sm cms">
                <div className="slider">
                  {medicalHistories.length === 0 && (
                    <p className="noSur">
                      {medicalHistoryAddNew ? null : "No medical histories"}
                    </p>
                  )}

                  {medicalHistoryAddNew && (
                    <form className="slide" onSubmit={handleNewMedicalHistory}>
                      <button type="submit">Save</button>

                      <div className="slideCont">
                        <p>
                          Medical History:{" "}
                          <>
<div className="relative w-full">
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => handleSearch(e.target.value)}
    onFocus={() => setShowSuggestions(true)}
    placeholder="Search by condition or symptoms..."
    className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-500"
  />

  {showSuggestions && filteredSuggestions.length > 0 && (
    <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
      {filteredSuggestions.map((suggestion) => (
        <div
          key={suggestion.id}
          className="p-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => handleSelectSuggestion(suggestion)}
        >
          <div className="text-sm text-gray-800">
            {suggestion.description || suggestion.long_description}
          </div>
          <div className="text-xs text-gray-500">
            Code: {suggestion.code}
          </div>
        </div>
      ))}
    </div>
  )}
</div>

                            {selectedDescription && (
                              <p className="complaint-description">
                                <i>{selectedDescription}</i>
                              </p>
                            )}
                          </>
                        </p>
                      </div>

                      <div className="slideCont">
                        <p>
                          Ongoing:{" "}
                          <b>
                            <input
                              className="border-2 border-gray-300 rounded-md p-1"
                              type="text"
                              value={medicalHistoryOngoing}
                              onChange={(e) =>
                                setMedicalHistoryOngoing(e.target.value)
                              }
                            />
                          </b>
                        </p>
                        <p>
                          On Medication:{" "}
                          <b>
                            <input
                              className="border-2 border-gray-300 rounded-md p-1"
                              type="text"
                              value={medicalHistoryOnMedication}
                              onChange={(e) =>
                                setMedicalHistoryOnMedication(e.target.value)
                              }
                            />
                          </b>
                        </p>
                        <p>
                          Well Managed:{" "}
                          <b>
                            <input
                              className="border-2 border-gray-300 rounded-md p-1"
                              type="text"
                              value={medicalHistoryWellManaged}
                              onChange={(e) =>
                                setMedicalHistoryWellManaged(e.target.value)
                              }
                            />
                          </b>
                        </p>
                      </div>

                      <div className="slideCont">
                        <p>
                          Since When:{" "}
                          <b>
                            <input
                              className="border-2 border-gray-300 rounded-md p-1"
                              type="date"
                              value={medicalHistorySinceDate}
                              onChange={(e) =>
                                setMedicalHistorySinceDate(e.target.value)
                              }
                            />
                          </b>
                        </p>
                      </div>

                      <div className="slideCont">
                        <p>
                          Description:{" "}
                          <i>
                            <input
                              className="medical-history-desc"
                              type="text"
                              value={medicalHistoryDescription}
                              onChange={(e) =>
                                setMedicalHistoryDescription(e.target.value)
                              }
                            />
                          </i>
                        </p>
                      </div>
                    </form>
                  )}

                  {medicalHistories.map((mh, index) => (
                    <form
                      className="slide"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleUpdateMedicalHistory(e, mh.id);
                      }}
                      key={mh.id}
                    >
                      <button
                        type="submit"
                        onClick={(e) => {
                          if (medicalHistoryEditIndex === mh.id) {
                            // If in edit mode, let form submission handle the save
                          } else {
                            e.preventDefault();
                            handleEditMedicalHistory(mh.id, mh);
                          }
                        }}
                        className="submit-button"
                      >
                        {medicalHistoryEditIndex === mh.id ? "Save" : "Edit"}
                      </button>

                      <div className="slideCont">
                        <p>
                          Medical History:{" "}
                          {medicalHistoryEditIndex === mh.id ? (
                            <>
                              <div className="relative w-full">
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => handleSearch(e.target.value)}
    onFocus={() => setShowSuggestions(true)}
    placeholder="Search by condition or symptoms..."
    className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-500"
  />
  
  {showSuggestions && filteredSuggestions.length > 0 && (
    <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
      {filteredSuggestions.map((suggestion) => (
        <div
          key={suggestion.id}
          className="p-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => handleSelectSuggestion(suggestion)}
        >
          <div className="text-sm text-gray-800">
            {suggestion.description || suggestion.long_description}
          </div>
          <div className="text-xs text-gray-500">
            Code: {suggestion.code}
          </div>
        </div>
      ))}
    </div>
  )}
</div>
                            </>
                          ) : (
                            <>
                              <b>
                                {
                                  complaintOptions.find(
                                    (opt) =>
                                      opt.id === parseInt(mh.complaint_code)
                                  )?.code
                                }
                              </b>
                              <p className="saved-medical-history-details">
                                <span className="medical-history-description">
                                  {
                                    complaintOptions.find(
                                      (opt) =>
                                        opt.id === parseInt(mh.complaint_code)
                                    )?.long_description
                                  }
                                </span>
                              </p>
                            </>
                          )}
                        </p>
                      </div>

                      <div className="slideCont">
                        <p>
                          Ongoing:{" "}
                          {medicalHistoryEditIndex === mh.id ? (
                            <input
                              type="text"
                              value={medicalHistoryOngoing}
                              onChange={(e) =>
                                setMedicalHistoryOngoing(e.target.value)
                              }
                              className="p-2 border rounded"
                            />
                          ) : (
                            <b>{mh.ongoing}</b>
                          )}
                        </p>
                        <p>
                          On Medication:{" "}
                          {medicalHistoryEditIndex === mh.id ? (
                            <input
                              type="text"
                              value={medicalHistoryOnMedication}
                              onChange={(e) =>
                                setMedicalHistoryOnMedication(e.target.value)
                              }
                              className="p-2 border rounded"
                            />
                          ) : (
                            <b>{mh.on_medication}</b>
                          )}
                        </p>
                        <p>
                          Well Managed:{" "}
                          {medicalHistoryEditIndex === mh.id ? (
                            <input
                              type="text"
                              value={medicalHistoryWellManaged}
                              onChange={(e) =>
                                setMedicalHistoryWellManaged(e.target.value)
                              }
                              className="p-2 border rounded"
                            />
                          ) : (
                            <b>{mh.well_managed}</b>
                          )}
                        </p>
                      </div>

                      <div className="slideCont">
                        <p>
                          Since When:{" "}
                          {medicalHistoryEditIndex === mh.id ? (
                            <input
                              type="date"
                              value={medicalHistorySinceDate}
                              onChange={(e) =>
                                setMedicalHistorySinceDate(e.target.value)
                              }
                              className="p-2 border rounded"
                            />
                          ) : (
                            <b>{mh.since_date}</b>
                          )}
                        </p>
                      </div>
                      <div className="slideCont">
                        <p>
                          Description:
                          {medicalHistoryEditIndex === mh.id ? (
                            <input
                              type="text"
                              value={medicalHistoryDescription}
                              onChange={(e) =>
                                setMedicalHistoryDescription(e.target.value)
                              }
                              className="p-2 border rounded"
                            />
                          ) : (
                            <i>{mh.description}</i>
                          )}
                        </p>
                      </div>
                    </form>
                  ))}
                </div>
              </div>
            </div>
            <p className="pages">
              {medicalHistories.length === 0 ? 0 : medicalHistoryEditIndex + 1}{" "}
              of {medicalHistories.length}
            </p>
          </div>
        </div>
      </div>

      <div className="d2lc">
        <div className="ccmMain">
          <div className="ccm">
            <div className="ccmTop">
              <h1>Medications</h1>
              <div className="udb">
                <button onClick={() => setMedAddNew(!medAddNew)}>
                  {medAddNew ? "Cancel" : "Add New"}
                </button>
              </div>
            </div>
            <div className="sliderMain">
              {!medAddNew && (
                <div className="sm">
                  {medications.length != 0 && (
                    <div className="sliderBtns">
                      <button className="left" onClick={handleMedLeftSlide}>
                        <img src={triangle} alt="triangle" />
                      </button>
                      <button className="right" onClick={handleMedRightSlide}>
                        <img src={triangle} alt="triangle" />
                      </button>
                    </div>
                  )}

                  <div className="sliderWindow">
                    <div
                      className="slider"
                      style={{
                        transform: `translateX(-${
                          (medIndex * 100) / medications.length
                        }%)`,
                        width: `${
                          medications.length === 0
                            ? 100
                            : medications.length * 100
                        }%`,
                      }}
                    >
                      {medications.length === 0 && (
                        <p className="noSur">No medications</p>
                      )}
                      {medications.map((md, index) => (
                        <form
                          className="slide"
                          onSubmit={(e) => handleUpdateMed(e, md.id)}
                          key={md.id}
                        >
                         <button
  type="submit" 
  onClick={(e) => {
    e.preventDefault();
    if (medEditIndex === index) {
      // This is a save action - handleUpdateMed will show the toast
      handleUpdateMed(e, md.id);
      setMedEditIndex(null);
    } else {
      // This is an edit action - just set the states
      setMedEditIndex(index);
      setDrugName(md.drug_name);
      setDrugStrength(md.drug_strength);
      setDrugFrequency(md.drug_frequency);
      setFromDate(md.from_date);
      setTillDate(md.till_date);
      setDuration(md.duration);
      setDescription(md.description);
    }
  }}
>
  {medEditIndex === index ? "Save" : "Edit"}
</button>

                          <div className="slideCont">
                            <p>
                              Drug Name:{" "}
                              {medEditIndex === index ? (
                                <>
                                  <input
                                    type="text"
                                    list="drugNames"
                                    value={
                                      drugNameChoices.find(
                                        (d) => d.id === parseInt(drugName)
                                      )?.name || drugName
                                    }
                                    onChange={(e) => {
                                      const selected = drugNameChoices.find(
                                        (d) => d.name === e.target.value
                                      );
                                      setDrugName(
                                        selected ? selected.id : e.target.value
                                      );
                                    }}
                                  />
                                  <datalist id="drugNames">
                                    {drugNameChoices.map((drug) => (
                                      <option key={drug.id} value={drug.name} />
                                    ))}
                                  </datalist>
                                </>
                              ) : (
                                <b>
                                  {drugNameChoices.find(
                                    (d) => d.id === parseInt(md.drug_name)
                                  )?.name || md.drug_name}
                                </b>
                              )}
                            </p>
                            <p>
                              Drug Strength:{" "}
                              {medEditIndex === index ? (
                                <>
                                  <input
                                    type="text"
                                    list="drugStrengths"
                                    value={
                                      drugStrengthChoices.find(
                                        (d) => d.id === parseInt(drugStrength)
                                      )?.name || drugStrength
                                    }
                                    onChange={(e) => {
                                      const selected = drugStrengthChoices.find(
                                        (d) => d.name === e.target.value
                                      );
                                      setDrugStrength(
                                        selected ? selected.id : e.target.value
                                      );
                                    }}
                                  />
                                  <datalist id="drugStrengths">
                                    {drugStrengthChoices.map((strength) => (
                                      <option
                                        key={strength.id}
                                        value={strength.name}
                                      />
                                    ))}
                                  </datalist>
                                </>
                              ) : (
                                <b>
                                  {drugStrengthChoices.find(
                                    (d) => d.id === parseInt(md.drug_strength)
                                  )?.name || md.drug_strength}
                                </b>
                              )}
                            </p>
                          </div>

                          <div className="slideCont">
                            <p>
                              Drug Frequency:{" "}
                              {medEditIndex === index ? (
                                <>
                                  <input
                                    type="text"
                                    list="drugFrequencies"
                                    value={
                                      drugFrequencyChoices.find(
                                        (d) => d.id === parseInt(drugFrequency)
                                      )?.name || drugFrequency
                                    }
                                    onChange={(e) => {
                                      const selected =
                                        drugFrequencyChoices.find(
                                          (d) => d.name === e.target.value
                                        );
                                      setDrugFrequency(
                                        selected ? selected.id : e.target.value
                                      );
                                    }}
                                  />
                                  <datalist id="drugFrequencies">
                                    {drugFrequencyChoices.map((freq) => (
                                      <option key={freq.id} value={freq.name} />
                                    ))}
                                  </datalist>
                                </>
                              ) : (
                                <b>
                                  {drugFrequencyChoices.find(
                                    (d) => d.id === parseInt(md.drug_frequency)
                                  )?.name || md.drug_frequency}
                                </b>
                              )}
                            </p>
                          </div>

                          <div className="slideCont">
                            <p>
                              From date:{" "}
                              {medEditIndex === index ? (
                                <input
                                  type="date"
                                  value={fromDate}
                                  onChange={(e) => setFromDate(e.target.value)}
                                />
                              ) : (
                                <b>{md.from_date}</b>
                              )}
                            </p>
                            <p>
                              Till date:{" "}
                              {medEditIndex === index ? (
                                <input
                                  type="date"
                                  value={tillDate}
                                  onChange={(e) => setTillDate(e.target.value)}
                                />
                              ) : (
                                <b>{md.till_date}</b>
                              )}
                            </p>
                            <p>
                              Duration:{" "}
                              {medEditIndex === index ? (
                                <input
                                  type="text"
                                  value={duration}
                                  onChange={(e) => setDuration(e.target.value)}
                                />
                              ) : (
                                <b>{md.duration}</b>
                              )}
                            </p>
                          </div>

                          <div className="slideCont">
                            <p>
                              Description:{" "}
                              {medEditIndex === index ? (
                                <input
                                  type="text"
                                  value={description}
                                  onChange={(e) =>
                                    setDescription(e.target.value)
                                  }
                                />
                              ) : (
                                <i>{md.description}</i>
                              )}
                            </p>
                          </div>
                        </form>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {medAddNew && (
                <form
                  style={{ width: "97%" }}
                  className="slide"
                  onSubmit={(e) => handleMedSubmit(e)}
                >
                  <button type="submit" onClick={() => setEdit(!edit)}>
                    {edit ? "Save" : "Edit"}
                  </button>

                  <div className="slideCont">
                    <p>
                      Drug Name:{" "}
                      {!medAddNew ? (
                        <b>
                          {drugNameChoices.find(
                            (d) => d.id === parseInt(drugName)
                          )?.name || drugName}
                        </b>
                      ) : (
                        <>
                          <input
                            type="text"
                            list="drugNames"
                            value={
                              drugNameChoices.find(
                                (d) => d.id === parseInt(drugName)
                              )?.name || drugName
                            }
                            onChange={(e) => {
                              const selected = drugNameChoices.find(
                                (d) => d.name === e.target.value
                              );
                              setDrugName(
                                selected ? selected.id : e.target.value
                              );
                            }}
                          />
                          <datalist id="drugNames">
                            {drugNameChoices.map((drug) => (
                              <option key={drug.id} value={drug.name} />
                            ))}
                          </datalist>
                        </>
                      )}
                    </p>
                    <p>
                      Drug Strength:{" "}
                      {!medAddNew ? (
                        <b>
                          {drugStrengthChoices.find(
                            (d) => d.id === parseInt(drugStrength)
                          )?.name || drugStrength}
                        </b>
                      ) : (
                        <>
                          <input
                            type="text"
                            list="drugStrengths"
                            value={
                              drugStrengthChoices.find(
                                (d) => d.id === parseInt(drugStrength)
                              )?.name || drugStrength
                            }
                            onChange={(e) => {
                              const selected = drugStrengthChoices.find(
                                (d) => d.name === e.target.value
                              );
                              setDrugStrength(
                                selected ? selected.id : e.target.value
                              );
                            }}
                          />
                          <datalist id="drugStrengths">
                            {drugStrengthChoices.map((strength) => (
                              <option key={strength.id} value={strength.name} />
                            ))}
                          </datalist>
                        </>
                      )}
                    </p>
                  </div>

                  <div className="slideCont">
                    <p>
                      Drug Frequency:{" "}
                      {!medAddNew ? (
                        <b>
                          {drugFrequencyChoices.find(
                            (d) => d.id === parseInt(drugFrequency)
                          )?.name || drugFrequency}
                        </b>
                      ) : (
                        <>
                          <input
                            type="text"
                            list="drugFrequencies"
                            value={
                              drugFrequencyChoices.find(
                                (d) => d.id === parseInt(drugFrequency)
                              )?.name || drugFrequency
                            }
                            onChange={(e) => {
                              const selected = drugFrequencyChoices.find(
                                (d) => d.name === e.target.value
                              );
                              setDrugFrequency(
                                selected ? selected.id : e.target.value
                              );
                            }}
                          />
                          <datalist id="drugFrequencies">
                            {drugFrequencyChoices.map((freq) => (
                              <option key={freq.id} value={freq.name} />
                            ))}
                          </datalist>
                        </>
                      )}
                    </p>
                  </div>

                  <div className="slideCont">
                    <p>
                      From date:{" "}
                      {!medAddNew ? (
                        <b>{fromDate}</b>
                      ) : (
                        <input
                          type="date"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      )}
                    </p>
                    <p>
                      Till date:{" "}
                      {!medAddNew ? (
                        <b>{tillDate}</b>
                      ) : (
                        <input
                          type="date"
                          value={tillDate}
                          onChange={(e) => setTillDate(e.target.value)}
                        />
                      )}
                    </p>
                  </div>

                  <div className="slideCont">
                    <p>
                      Description:{" "}
                      {!medAddNew ? (
                        <i>{description}</i>
                      ) : (
                        <input
                          type="text"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        />
                      )}
                    </p>
                  </div>
                </form>
              )}
              {!medAddNew && (
                <div className="smBtns">
                  {medications.map((md, index) => (
                    <div
                      className={medIndex == index ? "smb smbc" : "smb"}
                      onClick={() => setMedIndex(index)}
                      key={index}
                    ></div>
                  ))}
                </div>
              )}
            </div>
            {!medAddNew && (
              <p className="pages">
                {medications.length === 0 ? 0 : medIndex + 1} of{" "}
                {medications.length}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="d2lc">
        <div className="ccmMain">
          <div className="ccm">
            <div className="ccmTop">
              <h1>Family History</h1>
              <div className="udb">
                <button onClick={() => setFhAddNew(!fhAddNew)}>
                  {fhAddNew ? "Cancel" : "Add New"}
                </button>
              </div>
            </div>
            <div className="sliderMain">
              {!fhAddNew && (
                <div className="sm">
                  <div className="sliderBtns">
                    <button className="left" onClick={handleFhLeftSlide}>
                      <img src={triangle} alt="triangle" />
                    </button>
                    <button className="right" onClick={handleFhRightSlide}>
                      <img src={triangle} alt="triangle" />
                    </button>
                  </div>
                  <div className="sliderWindow">
                    <div
                      className="slider"
                      style={{
                        transform: `translateX(-${
                          (fhIndex * 100) / familyHistory.length
                        }%)`,
                        width: `${
                          familyHistory.length === 0
                            ? 100
                            : familyHistory.length * 100
                        }%`,
                      }}
                    >
                      {familyHistory.map((fh, index) => (
                        <form
                          className="slide"
                          key={index}
                          onSubmit={(e) => handleUpdateFh(e, fh.id)}
                        >
                       <button
  onClick={(e) => {
    e.preventDefault(); // Prevent form submission
    if (fhEditIndex === index) {
      // This is a save action - handleUpdateFh will show the toast
      handleUpdateFh(e, fh.id);
      setFhEditIndex(null);
      setEdit3(!edit3);
    } else {
      // This is an edit action - just set the states
      setEdit3(!edit3);
      setFhEditIndex(index); 
      setRelation(fh.relation);
      setDiagnosis(fh.diagnosis);
      setSw(fh.sins_when);
      setFhDesc(fh.descriptions);
    }
  }}
  style={{
    backgroundColor: edit3 ? "#F23D76BF" : "#F23D76",
    color: edit3 ? "#FFFFFF" : "#FFFFFF",
  }}
>
  {edit3 ? "Edit" : "Save"}
</button>
                          <div className="slideCont">
                            <p>
                              Relation:
                              {edit3 ? (
                                <b>{fh.relation}</b>
                              ) : (
                                <select
                                  value={relation}
                                  onChange={(e) => setRelation(e.target.value)}
                                >
                                  <option value="">Select Relation</option>
                                  <option value="Brother">Brother</option>
                                  <option value="Cousin Brother">
                                    Cousin Brother
                                  </option>
                                  <option value="Cousin Sister">
                                    Cousin Sister
                                  </option>
                                  <option value="Daughter">Daughter</option>
                                  <option value="Elder Brother">
                                    Elder Brother
                                  </option>
                                  <option value="Elder Sister">
                                    Elder Sister
                                  </option>
                                  <option value="Father">Father</option>
                                  <option value="Husband">Husband</option>
                                  <option value="Maternal Grandfather">
                                    Maternal Grandfather
                                  </option>
                                  <option value="Maternal Grandmother">
                                    Maternal Grandmother
                                  </option>
                                  <option value="Maternal Uncle">
                                    Maternal Uncle
                                  </option>
                                  <option value="Maternal Aunt">
                                    Maternal Aunt
                                  </option>
                                  <option value="Mother">Mother</option>
                                  <option value="Paternal Grandfather">
                                    Paternal Grandfather
                                  </option>
                                  <option value="Paternal Grandmother">
                                    Paternal Grandmother
                                  </option>
                                  <option value="Paternal Uncle">
                                    Paternal Uncle
                                  </option>
                                  <option value="Paternal Aunt">
                                    Paternal Aunt
                                  </option>
                                  <option value="Sister">Sister</option>
                                  <option value="Son">Son</option>
                                  <option value="Wife">Wife</option>
                                  <option value="Younger Brother">
                                    Younger Brother
                                  </option>
                                  <option value="Younger Sister">
                                    Younger Sister
                                  </option>
                                </select>
                              )}
                            </p>
                          </div>
                          <div className="slideCont">
  <p>
    Diagnosis:
    {fhEditIndex === index ? (
      <div className="relative w-full">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
          onFocus={() => setShowSuggestions(true)}
          placeholder="Search by condition or symptoms..."
          className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-500"
        />
        {showSuggestions && filteredSuggestions.length > 0 && (
          <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
            {filteredSuggestions.map((suggestion) => (
              <div
                key={suggestion.id}
                className="p-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelectSuggestion(suggestion)}
              >
                <div className="text-sm text-gray-800">
                  {suggestion.description || suggestion.long_description}
                </div>
                <div className="text-xs text-gray-500">
                  Code: {suggestion.code}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    ) : (
                                <>
                                  <b>
                                    {
                                      icdCodes.find(
                                        (code) =>
                                          code.id === parseInt(fh.diagnosis)
                                      )?.code
                                    }
                                  </b>
                                  {icdCodes.find(
                                    (code) => code.id === parseInt(fh.diagnosis)
                                  )?.description && (
                                    <p className="mt-1 text-sm text-gray-600 italic">
                                      {
                                        icdCodes.find(
                                          (code) =>
                                            code.id === parseInt(fh.diagnosis)
                                        )?.description
                                      }
                                    </p>
                                  )}
                                </>
                              )}
                            </p>
                          </div>
                          <div className="slideCont">
                            <p>
                              Since When:
                              {edit3 ? (
                                <b>{fh.sins_when}</b>
                              ) : (
                                <input
                                  type="date"
                                  value={sw}
                                  onChange={(e) => {
                                    setSw(e.target.value);
                                  }}
                                />
                              )}
                            </p>
                          </div>
                          <div className="slideCont">
                            <div className="alg algDesc">
                              <p>Description :</p>
                              {!edit3 ? (
                                <textarea
                                  value={fhDesc}
                                  style={{
                                    border: edit3
                                      ? "none"
                                      : "1px solid #707070",
                                    fontWeight: "bold",
                                    fontSize: 18,
                                  }}
                                  onChange={(e) => setFhDesc(e.target.value)}
                                ></textarea>
                              ) : (
                                <b>{fh.descriptions}</b>
                              )}
                            </div>
                          </div>
                        </form>
                      ))}
                      {familyHistory.length === 0 && (
                        <div className="slide">
                          {/* <button
                        onClick={() => setEdit3(!edit3)}
                        style={{
                          backgroundColor: edit3 ? "transparent" : "#F23D76",
                          color: edit3 ? "#F23D76" : "#FFFFFF",
                        }}
                      >
                        {edit3 ? "Edit" : "Save"}
                      </button> */}
                          <div className="slideCont">
                            <p>
                              Relation:
                              <b>none</b>
                            </p>
                          </div>
                          <div className="slideCont">
                            <p>
                              Diagnosis:
                              <b>none</b>
                            </p>
                          </div>
                          <div className="slideCont">
                            <p>
                              Since When:
                              <b>none</b>
                            </p>
                          </div>
                          <div className="slideCont">
                            <div className="alg algDesc">
                              <p>Description :</p>
                              <b>none</b>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {fhAddNew && (
                <form
                  style={{ width: "97%" }}
                  className="slide"
                  onSubmit={(e) => handleFhSubmit(e)}
                >
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "#F23D76",
                      color: "#FFFFFF",
                    }}
                  >
                    Save
                  </button>
                  <div className="slideCont">
                    <p>
                      Relation:
                      <select
                        value={relation}
                        onChange={(e) => setRelation(e.target.value)}
                      >
                        <option value="">Select Relation</option>
                                  <option value="Brother">Brother</option>
                                  <option value="Cousin Brother">
                                    Cousin Brother
                                  </option>
                                  <option value="Cousin Sister">
                                    Cousin Sister
                                  </option>
                                  <option value="Daughter">Daughter</option>
                                  <option value="Elder Brother">
                                    Elder Brother
                                  </option>
                                  <option value="Elder Sister">
                                    Elder Sister
                                  </option>
                                  <option value="Father">Father</option>
                                  <option value="Husband">Husband</option>
                                  <option value="Maternal Grandfather">
                                    Maternal Grandfather
                                  </option>
                                  <option value="Maternal Grandmother">
                                    Maternal Grandmother
                                  </option>
                                  <option value="Maternal Uncle">
                                    Maternal Uncle
                                  </option>
                                  <option value="Maternal Aunt">
                                    Maternal Aunt
                                  </option>
                                  <option value="Mother">Mother</option>
                                  <option value="Paternal Grandfather">
                                    Paternal Grandfather
                                  </option>
                                  <option value="Paternal Grandmother">
                                    Paternal Grandmother
                                  </option>
                                  <option value="Paternal Uncle">
                                    Paternal Uncle
                                  </option>
                                  <option value="Paternal Aunt">
                                    Paternal Aunt
                                  </option>
                                  <option value="Sister">Sister</option>
                                  <option value="Son">Son</option>
                                  <option value="Wife">Wife</option>
                                  <option value="Younger Brother">
                                    Younger Brother
                                  </option>
                                  <option value="Younger Sister">
                                    Younger Sister
                                  </option>
                      </select>
                    </p>
                  </div>
                  <div className="slideCont">
  <p>
    Diagnosis:
    <div className="relative w-full">
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => handleSearch(e.target.value)}
        onFocus={() => setShowSuggestions(true)}
        placeholder="Search by condition or symptoms..."
        className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-500"
      />
      {showSuggestions && filteredSuggestions.length > 0 && (
        <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
          {filteredSuggestions.map((suggestion) => (
            <div
              key={suggestion.id}
              className="p-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => handleSelectSuggestion(suggestion)}
            >
              <div className="text-sm text-gray-800">
                {suggestion.description || suggestion.long_description}
              </div>
              <div className="text-xs text-gray-500">
                Code: {suggestion.code}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </p>
</div>
                  <div className="slideCont">
                    <p>
                      Since When:
                      <input
                        type="date"
                        value={sw}
                        onChange={(e) => {
                          setSw(e.target.value);
                        }}
                      />
                    </p>
                  </div>
                  <div className="slideCont">
                    <div className="alg algDesc">
                      <p>Description :</p>
                      <textarea
                        value={fhDesc}
                        style={{
                          border: "1px solid #707070",
                        }}
                        onChange={(e) => setFhDesc(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </form>
              )}
              {!fhAddNew && (
                <div className="smBtns">
                  {familyHistory.map((md, index) => (
                    <div
                      className={fhIndex == index ? "smb smbc" : "smb"}
                      onClick={() => setFhIndex(index)}
                      key={index}
                    ></div>
                  ))}
                </div>
              )}
            </div>
            <p className="pages">
              {familyHistory.length === 0 ? 0 : fhIndex + 1} of{" "}
              {familyHistory.length}
            </p>
          </div>
        </div>
      </div>
      <div className="d2lc">
        <div className="ccmMain">
          <div className="ccm">
            <div className="ccmTop">
              <h1>Surgical History</h1>
              <div className="udb">
              <button onClick={() => {
  if (!shAddNew) {
    setShAddNew(true);
    setSurgery(""); 
    setWid(""); 
    setShDesc(""); 
  } else {
    setShAddNew(false);
  }
}}>
  {shAddNew ? "Cancel" : "Add New"}
</button>
              </div>
            </div>
            <div className="sliderMain gs">
              {!shAddNew && (
                <div className="sm">
                  {surgicalHistory.length != 0 && (
                    <div className="sliderBtns">
                      <button className="left" onClick={handleShLeftSlide}>
                        <img src={triangle} alt="triangle" />
                      </button>
                      <button className="right" onClick={handleShRightSlide}>
                        <img src={triangle} alt="triangle" />
                      </button>
                    </div>
                  )}

                  <div className="sliderWindow">
                    <div
                      className="slider"
                      style={{
                        transform: `translateX(-${
                          (shIndex * 100) / surgicalHistory.length
                        }%)`,
                        width: `${surgicalHistory.length * 100}%`,
                      }}
                    >
                      {surgicalHistory.length === 0 && (
                        <p className="noSur">No surgical history</p>
                      )}
                     {surgicalHistory.map((sh, index) => (
  <form
    key={sh.id}
    className="slide"
    onSubmit={(e) => handleUpdateSh(e, sh.id)}
  >
    <button
      onClick={(e) => {
        e.preventDefault();
        if (shEditIndex === index) {
          // This is a save action - handleUpdateSh will show the toast
          handleUpdateSh(e, sh.id);
          setShEditIndex(null);
        } else {
          // This is an edit action - just set the states
          setShEditIndex(index); 
          setSurgery(sh.surgery);
          setWid(sh.when_dose);
          setShDesc(sh.description);
        }
      }}
      style={{
        backgroundColor: shEditIndex === index ? "#F23D76" : "#F23D76BF",
        color: shEditIndex === index ? "#FFFFFF" : "#FFFFFF",
      }}
    >
      {shEditIndex === index ? "Save" : "Edit"}
    </button>

                          <div className="slideCont">
                            <p>
                              Surgery:
                              {shEditIndex === index ? (
                                <select
                                  value={surgery}
                                  onChange={(e) => handleSurgery(e)}
                                >
                                  <option value="">Select surgery</option>
                                  {surgeryOptions.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <b>{surgeryOptions[sh.surgery - 1]?.name}</b>
                              )}
                              {console.log(
                                surgeryOptions[sh.surgery],
                                "YEHJHJYUIYUYUIYIUYIUYIYIUYUIYIUYIUYUIYIUYIUYIUYIUYUIYIU"
                              )}
                              {console.log(surgeryOptions)}
                              {console.log(surgery)}
                            </p>
                          </div>

                          <div className="slideCont">
                            <p>
                              When it was done:
                              {shEditIndex === index ? (
                                <input
                                  type="date"
                                  value={wid}
                                  onChange={(e) => setWid(e.target.value)}
                                />
                              ) : (
                                <b>{sh.when_dose}</b>
                              )}
                            </p>
                          </div>

                          <div className="slideCont">
                            <div className="alg algDesc">
                              <p>Description :</p>
                              {shEditIndex === index ? (
                                <textarea
                                  value={shDesc}
                                  style={{
                                    border: "1px solid #707070",
                                    fontWeight: "bold",
                                    fontSize: 18,
                                  }}
                                  onChange={(e) => setShDesc(e.target.value)}
                                ></textarea>
                              ) : (
                                <b>{sh.description}</b>
                              )}
                            </div>
                          </div>
                        </form>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {shAddNew && (
                <form
                  className="slide"
                  style={{ width: "97%" }}
                  onSubmit={(e) => handleShSubmit(e)}
                >
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "#F23D76",
                      color: "#FFFFFF",
                    }}
                  >
                    Save
                  </button>
                  <div className="slideCont">
                    <p>
                      Surgery:
                      <select
                        value={surgery}
                        onChange={(e) => setSurgery(e.target.value)}
                      >
                       <option value="">Select surgery</option>
                                  {surgeryOptions.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.name}
                                    </option>
                                  ))}
                      </select>
                    </p>
                  </div>
                  <div className="slideCont">
                    <p>
                      When it was done:
                      <input
                        type="date"
                        value={wid}
                        onChange={(e) => {
                          setWid(e.target.value);
                        }}
                      />
                    </p>
                  </div>
                  <div className="slideCont">
                    <div className="alg algDesc">
                      <p>Description :</p>
                      <textarea
                        value={shDesc}
                        style={{
                          border: "1px solid #707070",
                        }}
                        onChange={(e) => setShDesc(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </form>
              )}

              {!shAddNew && (
                <div className="smBtns">
                  {surgicalHistory.map((sh, index) => (
                    <div
                      className={shIndex == index ? "smb smbc" : "smb"}
                      onClick={() => setShIndex(index)}
                    ></div>
                  ))}
                </div>
              )}
            </div>
            <p className="pages">
              {surgicalHistory.length === 0 ? 0 : shIndex + 1} of{" "}
              {surgicalHistory.length}
            </p>
          </div>
        </div>
      </div>
      <div className="ccm goalSet">
        <div className="ccmTop">
          <h1 className="text-2xl font-semibold mb-4">Food preferences</h1>
        </div>
        <div className="slide bg-white rounded-lg shadow-md p-6">
          <div className="slideCont">
            <div className="scdc space-y-6">
              {/* Food Preferences Section */}
              <div className="scInfo bg-gray-50 p-4 rounded-lg">
                <div className="sci grid grid-cols-2 md:grid-cols-3 gap-4">
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
                    <label
                      key={value}
                      className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded"
                    >
                      <input
                        type="checkbox"
                        value={value}
                        checked={healthProblems.includes(value)}
                        onChange={() => handleHp(value)}
                        disabled={edit5 && !globalEdit}
                        className="form-checkbox h-4 w-4 text-pink-500 rounded border-gray-300 focus:ring-pink-500"
                      />{" "}
                      <span
                        className={`${`ml-3 ${(edit5 && !globalEdit && !healthProblems.includes(value)) 
      ? 'text-gray-300' 
      : 'text-gray-700'}`}`}
                      >
                        {getFoodPreferenceName(value)}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Likes & Dislikes Section */}
              <div className="grid md:grid-cols-2 gap-6">
                <div className="alg">
                  <p className="font-medium text-gray-700 mb-2">Likes</p>
                  {edit5 && !globalEdit ? (
                    <b className="block p-3 bg-gray-50 rounded-lg">
                      {dietPref.likes || "None specified"}
                    </b>
                  ) : (
                    <textarea
                      value={fpLikes}
                      onChange={(e) => setFpLikes(e.target.value)}
                      className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                      style={{
                        border:
                          edit5 && !globalEdit ? "none" : "1px solid #707070",
                        minHeight: "100px",
                      }}
                      readOnly={edit5 && !globalEdit}
                    />
                  )}
                </div>

                <div className="alg">
                  <p className="font-medium text-gray-700 mb-2">Dislikes</p>
                  {edit5 && !globalEdit ? (
                    <b className="block p-3 bg-gray-50 rounded-lg">
                      {dietPref.dislikes || "None specified"}
                    </b>
                  ) : (
                    <textarea
                      value={fpDislikes}
                      onChange={(e) => setFpDislikes(e.target.value)}
                      className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                      style={{
                        border:
                          edit5 && !globalEdit ? "none" : "1px solid #707070",
                        minHeight: "100px",
                      }}
                      readOnly={edit5 && !globalEdit}
                    />
                  )}
                </div>
              </div>

              {/* Oil Type Section */}
              <div className="sc bg-gray-50 p-4 rounded-lg">
                <p className="font-medium text-gray-700 mb-3">Oil Type:</p>
                <div className="sci grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
                  {[1, 2, 3, 4, 5, 6].map((value) => (
                    <label
                      key={value}
                      className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded"
                    >
                      <input
                        type="checkbox"
                        value={value}
                        checked={selectedOilTypes.includes(value)}
                        onChange={(e) => handleHp2(e.target.value)}
                        disabled={edit5 && !globalEdit}
                        className="form-checkbox h-4 w-4 text-pink-500 rounded border-gray-300 focus:ring-pink-500"
                      />{" "}
                      <span
  className={`ml-3 ${(edit5 && !globalEdit && !selectedOilTypes.includes(value)) 
    ? 'text-gray-300' 
    : 'text-gray-700'}`}
>
  {getOilTypeName(value)}
</span>
                    </label>
                  ))}
                </div>

                <div className="oiNum flex items-center space-x-4">
                  <p className="font-medium text-gray-700">
                    Oil intake (liter/month):{" "}
                  </p>
                  {edit5 && !globalEdit ? (
                    <b className="p-2 bg-white rounded">
                      {dietPref.oil_intake_per_month || "Not specified"}
                    </b>
                  ) : (
                    <input
                      min={0}
                      type="number"
                      value={oiPerM}
                      onChange={(e) => setOiPerM(e.target.value)}
                      disabled={edit5 && !globalEdit}
                      className="w-24 p-2 border rounded focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                    />
                  )}
                </div>
              </div>

              {/* Salt Section */}
              <div className="sc bg-gray-50 p-4 rounded-lg">
                <p className="font-medium text-gray-700 mb-3">Salt:</p>
                <div className="sci grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
                  {[1, 2].map((value) => (
                    <label
                      key={value}
                      className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded"
                    >
                      <input
                        type="checkbox"
                        value={value}
                        checked={healthProblems3.includes(value)}
                        onChange={(e) => handleHp3(e.target.value)}
                        disabled={edit5 && !globalEdit}
                        className="form-checkbox h-4 w-4 text-pink-500 rounded border-gray-300 focus:ring-pink-500"
                      />{" "}
                      <span
  className={`ml-3 ${(edit5 && !globalEdit && !healthProblems3.includes(value)) 
    ? 'text-gray-300' 
    : 'text-gray-700'}`}
>
  {getSaltTypeName(value)}
</span>
                    </label>
                  ))}
                </div>

                <div className="oiNum flex items-center space-x-4">
                  <p className="font-medium text-gray-700">
                    Salt intake (Kg/month):
                  </p>
                  {edit5 && !globalEdit ? (
                    <b className="p-2 bg-white rounded">
                      {dietPref.salt_inlake || "Not specified"}
                    </b>
                  ) : (
                    <input
                      min={0}
                      type="number"
                      value={siPerM}
                      onChange={(e) => setSiPerM(e.target.value)}
                      disabled={edit5 && !globalEdit}
                      className="w-24 p-2 border rounded focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                    />
                  )}
                </div>
              </div>

              {/* Flour type Section */}
              <div className="sc alg bg-gray-50 p-4 rounded-lg">
                <p className="font-medium text-gray-700 mb-3">Flour type:</p>
                <div className="sci grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
                  {[1, 2, 3].map((value) => (
                    <label
                      key={value}
                      className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded"
                    >
                      <input
                        type="checkbox"
                        value={value}
                        checked={healthProblems4.includes(value)}
                        onChange={(e) => handleHp4(e.target.value)}
                        disabled={edit5 && !globalEdit}
                        className="form-checkbox h-4 w-4 text-pink-500 rounded border-gray-300 focus:ring-pink-500"
                      />{" "}
                      <span
          className={`ml-3 ${(edit5 && !globalEdit && !healthProblems4.includes(value)) 
            ? 'text-gray-300' 
            : 'text-gray-700'}`}
        >
          {getFlourTypeName(value)}
        </span>
                    </label>
                  ))}
                </div>

                <div className="scText">
                  <p className="font-medium text-gray-700 mb-2">
                    If other specify:
                  </p>
                  {edit5 && !globalEdit ? (
                    <b className="block p-3 bg-gray-50 rounded-lg">
                      {dietPref.flour_type_other || "Not specified"}
                    </b>
                  ) : (
                    <textarea
                      value={otFlour}
                      onChange={(e) => setOtFlour(e.target.value)}
                      className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                      style={{
                        border:
                          edit5 && !globalEdit ? "none" : "1px solid #707070",
                        minHeight: "100px",
                      }}
                      readOnly={edit5 && !globalEdit}
                    />
                  )}
                </div>
              </div>

              {/* Milk type Section */}
              <div className="sc alg bg-gray-50 p-4 rounded-lg">
                <p className="font-medium text-gray-700 mb-3">Milk type:</p>
                <div className="sci grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
                  {[1, 2, 3, 4, 5, 6].map((value) => (
                    <label
                      key={value}
                      className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded"
                    >
                      <input
                        type="checkbox"
                        value={value}
                        checked={healthProblems5.includes(value)}
                        onChange={(e) => handleHp5(e.target.value)}
                        disabled={edit5 && !globalEdit}
                        className="form-checkbox h-4 w-4 text-pink-500 rounded border-gray-300 focus:ring-pink-500"
                      />{" "}
                      <span
                        className={`${`ml-3 ${(edit5 && !globalEdit && !healthProblems.includes(value)) 
      ? 'text-gray-300' 
      : 'text-gray-700'}`}`}
                      >
                        {getMilkTypeName(value)}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Milk products Section */}
              <div className="sc alg bg-gray-50 p-4 rounded-lg">
                <p className="font-medium text-gray-700 mb-3">Milk products:</p>
                <div className="sci grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
                  {[1, 2, 3, 4, 5].map((value) => (
                    <label
                      key={value}
                      className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded"
                    >
                      <input
                        type="checkbox"
                        value={value}
                        checked={healthProblems6.includes(value)}
                        onChange={(e) => handleHp6(e.target.value)}
                        disabled={edit5 && !globalEdit}
                        className="form-checkbox h-4 w-4 text-pink-500 rounded border-gray-300 focus:ring-pink-500"
                      />{" "}
                       <span
  className={`ml-3 ${(edit5 && !globalEdit && !healthProblems6.includes(value)) 
    ? 'text-gray-300' 
    : 'text-gray-700'}`}
>
  {getMilkProductName(value)}
</span>
                    </label>
                  ))}
                </div>

                <div className="scText">
                  <p className="font-medium text-gray-700 mb-2">
                    If other specify:
                  </p>
                  {edit5 && !globalEdit ? (
                    <b className="block p-3 bg-gray-50 rounded-lg">
                      {dietPref.milk_product_other || "Not specified"}
                    </b>
                  ) : (
                    <textarea
                      value={otMilk}
                      onChange={(e) => setOtMilk(e.target.value)}
                      className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                      style={{
                        border:
                          edit5 && !globalEdit ? "none" : "1px solid #707070",
                        minHeight: "100px",
                      }}
                      readOnly={edit5 && !globalEdit}
                    />
                  )}
                </div>
              </div>

              <div className="mt-8 bg-white rounded-lg shadow">
                <p className="font-medium text-gray-700 ">Dietary Recall:</p>
                <DietaryRecallTable patientId={id} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d2lc">
        <div className="ccmMain">
          <div className="ccm">
            <div className="ccmTop">
              <h1>Other Information</h1>
            </div>

            <div className="sliderMain">
              <div className="slide daSlide">
                {/* Water Intake & Quantity */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  <div className="slideCont bg-gray-50 p-4 rounded-lg">
                    <p className="text-gray-700 font-medium mb-2">
                      Water Intake Type:
                    </p>
                    <div className="scOpt">
                      <select
                        value={otherInfo.water_intake}
                        onChange={(e) =>
                          (!edit6 || globalEdit) &&
                          setOtherInfo({
                            ...otherInfo,
                            water_intake: Number(e.target.value),
                          })
                        }
                        disabled={edit6 && !globalEdit}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                      >
                        <option value={2}>Glasses</option>
                        <option value={1}>Litre</option>
                      </select>
                    </div>
                  </div>

                  <div className="slideCont bg-gray-50 p-4 rounded-lg">
                    <p className="text-gray-700 font-medium mb-2">
                      Water Intake Quantity:
                    </p>
                    <div className="scOpt">
                      <input
                        min={0}
                        type="number"
                        value={otherInfo.water_intake_quantity}
                        onChange={(e) =>
                          (!edit6 || globalEdit) &&
                          setOtherInfo({
                            ...otherInfo,
                            water_intake_quantity: Number(e.target.value),
                          })
                        }
                        disabled={edit6 && !globalEdit}
                        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                      />
                    </div>
                  </div>
                </div>

                {/* Daily Metrics */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                  {[
                    {
                      label: "Urination Count",
                      field: "urination_count",
                      unit: "Times/day",
                    },
                    {
                      label: "Stool Frequency",
                      field: "stool_frequency",
                      unit: "Times/day",
                    },
                    {
                      label: "Sleep",
                      field: "sleep_hours",
                      unit: "Hours",
                    },
                  ].map((metric) => (
                    <div
                      key={metric.field}
                      className="slideCont bg-gray-50 p-4 rounded-lg"
                    >
                      <p className="text-gray-700 font-medium mb-2">
                        {metric.label}:
                      </p>
                      <div className="scOpt flex items-center space-x-2">
                        <input
                          min={0}
                          type="number"
                          value={otherInfo[metric.field]}
                          onChange={(e) =>
                            (!edit6 || globalEdit) &&
                            setOtherInfo({
                              ...otherInfo,
                              [metric.field]: Number(e.target.value),
                            })
                          }
                          disabled={edit6 && !globalEdit}
                          className="flex-1 p-2 border rounded-md focus:ring-2 focus:ring-pink-500 focus:border-transparent"
                        />
                        <span className="text-gray-600">{metric.unit}</span>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Medical Equipment */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  {[
                    {
                      label: "Spectacles",
                      field: "spectacles",
                    },
                    {
                      label: "Has BP Monitor",
                      field: "has_bp_monitor",
                    },
                    {
                      label: "Has Glucometer Monitor",
                      field: "has_glucometer_monitor",
                    },
                    {
                      label: "Has Weighing Monitor",
                      field: "has_weighing_monitor",
                    },
                  ].map((equipment) => (
                    <div
                      key={equipment.field}
                      className="slideCont bg-gray-50 p-4 rounded-lg"
                    >
                      <p className="text-gray-700 font-medium mb-2">
                        {equipment.label}:
                      </p>
                      <div className="scOpt flex space-x-4">
                        {["YES", "NO"].map((value) => (
                          <label
                            key={value}
                            className="flex items-center space-x-2 cursor-pointer"
                          >
                            <input
                              type="radio"
                              checked={otherInfo[equipment.field] === value}
                              onChange={() =>
                                (!edit6 || globalEdit) &&
                                setOtherInfo({
                                  ...otherInfo,
                                  [equipment.field]: value,
                                })
                              }
                              disabled={edit6 && !globalEdit}
                              className="form-radio text-pink-500 focus:ring-pink-500"
                            />
                            <span 
              className={`${(edit6 && !globalEdit && otherInfo[equipment.field] !== value) 
                ? 'text-gray-300' 
                : 'text-gray-700'}`}
            >
              {value}
            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                {/* Assessment Questions */}
                <div className="space-y-4">
                  {[
                    {
                      label: "How do you feel when you wake up?",
                      field: "wake_up_feeling",
                      options: [
                        { value: 1, label: "Excited" },
                        { value: 2, label: "Rested" },
                        { value: 3, label: "Tired" },
                      ],
                    },
                    {
                      label: "How do you feel for most of the day?",
                      field: "energy_level",
                      options: [
                        { value: 1, label: "Full of Energy" },
                        { value: 2, label: "Low on Energy" },
                        { value: 3, label: "No Energy at all" },
                      ],
                    },
                    {
                      label: "How stressed are you?",
                      field: "stress_level",
                      options: [
                        { value: 5, label: "Rarely" },
                        { value: 6, label: "Several days in a week" },
                        { value: 7, label: "Most of the time" },
                      ],
                    },
                    {
                      label: "How much time do you spend with family?",
                      field: "family_time",
                      options: [
                        { value: 1, label: "Not able to spend time" },
                        { value: 2, label: "Spends some time" },
                        { value: 3, label: "Spends a lot of time" },
                      ],
                    },
                    {
                      label: "Rate patient on health literacy",
                      field: "health_literacy",
                      options: [
                        { value: 1, label: "Good" },
                        { value: 2, label: "Average" },
                        { value: 3, label: "Poor" },
                      ],
                    },
                  ].map((question) => (
                    <div
                      key={question.field}
                      className="slideCont bg-gray-50 p-4 rounded-lg"
                    >
                      <p className="text-gray-700 font-medium mb-3">
                        {question.label}
                      </p>
                      <div className="scOpt grid grid-cols-1 md:grid-cols-3 gap-4">
                        {question.options.map((option) => (
                          <label
                            key={option.value}
                            className="flex items-center space-x-2 cursor-pointer"
                          >
                            <input
                              type="radio"
                              checked={
                                otherInfo[question.field] === option.value
                              }
                              onChange={() =>
                                (!edit6 || globalEdit) &&
                                setOtherInfo({
                                  ...otherInfo,
                                  [question.field]: option.value,
                                })
                              }
                              disabled={edit6 && !globalEdit}
                              className="form-radio text-pink-500 focus:ring-pink-500"
                            />
                           <span 
              className={`${(edit6 && !globalEdit && otherInfo[question.field] !== option.value) 
                ? 'text-gray-300' 
                : 'text-gray-700'}`}
            >
              {option.label}
            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailedAssessment;
